/* tslint:disable */
/* eslint-disable */
/**
 * Resell Customer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 16.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AFDParentCategoriesDto
 */
export interface AFDParentCategoriesDto {
    /**
     * 
     * @type {string}
     * @memberof AFDParentCategoriesDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AFDParentCategoriesDto
     */
    'title'?: string;
    /**
     * 
     * @type {Array<AFDQuestionsDto>}
     * @memberof AFDParentCategoriesDto
     */
    'questions'?: Array<AFDQuestionsDto>;
}
/**
 * 
 * @export
 * @interface AFDQuestionsDto
 */
export interface AFDQuestionsDto {
    /**
     * 
     * @type {string}
     * @memberof AFDQuestionsDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AFDQuestionsDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'address_line'?: string;
    /**
     * 
     * @type {Country}
     * @memberof AddressDto
     */
    'country'?: Country;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    'postal_code'?: string;
    /**
     * 
     * @type {object}
     * @memberof AddressDto
     */
    'additional_instructions'?: object;
    /**
     * 
     * @type {Location}
     * @memberof AddressDto
     */
    'location'?: Location;
    /**
     * 
     * @type {ContactInformation}
     * @memberof AddressDto
     */
    'contact_information'?: ContactInformation;
    /**
     * 
     * @type {GeopoliticalSubdivisions}
     * @memberof AddressDto
     */
    'geopolitical_subdivisions'?: GeopoliticalSubdivisions;
}
/**
 * 
 * @export
 * @interface AmandaImageDto
 */
export interface AmandaImageDto {
    /**
     * 
     * @type {number}
     * @memberof AmandaImageDto
     */
    'version'?: number;
    /**
     * 
     * @type {string}
     * @memberof AmandaImageDto
     */
    'md5'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmandaImageDto
     */
    'deliveryURL'?: string;
}
/**
 * 
 * @export
 * @interface ApplicationContext
 */
export interface ApplicationContext {
    /**
     * 
     * @type {ApplicationContext}
     * @memberof ApplicationContext
     */
    'parent'?: ApplicationContext;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    'displayName'?: string;
    /**
     * 
     * @type {object}
     * @memberof ApplicationContext
     */
    'autowireCapableBeanFactory'?: object;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    'applicationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationContext
     */
    'startupDate'?: number;
    /**
     * 
     * @type {Environment}
     * @memberof ApplicationContext
     */
    'environment'?: Environment;
    /**
     * 
     * @type {number}
     * @memberof ApplicationContext
     */
    'beanDefinitionCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationContext
     */
    'beanDefinitionNames'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof ApplicationContext
     */
    'parentBeanFactory'?: object;
    /**
     * 
     * @type {ApplicationContextClassLoader}
     * @memberof ApplicationContext
     */
    'classLoader'?: ApplicationContextClassLoader;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoader
 */
export interface ApplicationContextClassLoader {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoader
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoader
     */
    'registeredAsParallelCapable'?: boolean;
    /**
     * 
     * @type {ApplicationContextClassLoaderParent}
     * @memberof ApplicationContextClassLoader
     */
    'parent'?: ApplicationContextClassLoaderParent;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModule}
     * @memberof ApplicationContextClassLoader
     */
    'unnamedModule'?: ApplicationContextClassLoaderParentUnnamedModule;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner>}
     * @memberof ApplicationContextClassLoader
     */
    'definedPackages'?: Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoader
     */
    'defaultAssertionStatus'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParent
 */
export interface ApplicationContextClassLoaderParent {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParent
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParent
     */
    'registeredAsParallelCapable'?: boolean;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModule}
     * @memberof ApplicationContextClassLoaderParent
     */
    'unnamedModule'?: ApplicationContextClassLoaderParentUnnamedModule;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner>}
     * @memberof ApplicationContextClassLoaderParent
     */
    'definedPackages'?: Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParent
     */
    'defaultAssertionStatus'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModule
 */
export interface ApplicationContextClassLoaderParentUnnamedModule {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'name'?: string;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleClassLoader}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'classLoader'?: ApplicationContextClassLoaderParentUnnamedModuleClassLoader;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleDescriptor}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'descriptor'?: ApplicationContextClassLoaderParentUnnamedModuleDescriptor;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'named'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {Set<string>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'packages'?: Set<string>;
    /**
     * 
     * @type {object}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    'layer'?: object;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleClassLoader
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleClassLoader {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    'registeredAsParallelCapable'?: boolean;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    'definedPackages'?: Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    'defaultAssertionStatus'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'name'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'sealed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'specificationTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'specificationVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'specificationVendor'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'implementationTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'implementationVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackagesInner
     */
    'implementationVendor'?: string;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleDescriptor
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleDescriptor {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleDescriptor
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleDescriptor
     */
    'automatic'?: boolean;
}
/**
 * 
 * @export
 * @interface AskForDetailsDto
 */
export interface AskForDetailsDto {
    /**
     * 
     * @type {Array<AFDParentCategoriesDto>}
     * @memberof AskForDetailsDto
     */
    'categories'?: Array<AFDParentCategoriesDto>;
}
/**
 * 
 * @export
 * @interface AskForDetailsRequestDto
 */
export interface AskForDetailsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof AskForDetailsRequestDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AskForDetailsRequestDto
     */
    'customerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AskForDetailsRequestDto
     */
    'productId'?: number;
    /**
     * 
     * @type {AskForDetailsDto}
     * @memberof AskForDetailsRequestDto
     */
    'data'?: AskForDetailsDto;
}
/**
 * 
 * @export
 * @interface AuthenticationResponse
 */
export interface AuthenticationResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface BuyerOrderItemGroupSummaryDto
 */
export interface BuyerOrderItemGroupSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'expeditionId'?: number;
    /**
     * 
     * @type {CustomerItxDataDto}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'seller'?: CustomerItxDataDto;
    /**
     * 
     * @type {Set<OrderItemItxSummaryDto>}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'items'?: Set<OrderItemItxSummaryDto>;
    /**
     * 
     * @type {OrderState}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'state'?: OrderState;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'address'?: number;
    /**
     * 
     * @type {AddressDto}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'fullAddress'?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'earlyArrivingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'lateArrivingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'boughtDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'shippingDateLimit'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'shippedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'inTransitDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'incidenceDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'deliveredDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'cancellationDate'?: string;
    /**
     * 
     * @type {CancellationType}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'cancellationType'?: CancellationType;
    /**
     * 
     * @type {IncidenceType}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'incidenceType'?: IncidenceType;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'trackingUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'isLost'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'disputeDate'?: string;
    /**
     * 
     * @type {DisputeResolutionType}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'disputeResolutionType'?: DisputeResolutionType;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'paidDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'acceptanceDate'?: string;
    /**
     * 
     * @type {RejectionType}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'rejectionType'?: RejectionType;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'rejectionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'dropPointDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerOrderItemGroupSummaryDto
     */
    'dropPoint'?: boolean;
}


/**
 * 
 * @export
 * @interface BuyerOrderProductItxSummaryDto
 */
export interface BuyerOrderProductItxSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'title'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {ProductState}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'productState'?: ProductState;
    /**
     * 
     * @type {Array<string>}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'conditionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'colorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'sizeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'catalogDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BuyerOrderProductItxSummaryDto
     */
    'manualEntry'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CancellationType = {
    Manual: 'MANUAL',
    Auto: 'AUTO',
    Returned: 'RETURNED'
} as const;

export type CancellationType = typeof CancellationType[keyof typeof CancellationType];


/**
 * 
 * @export
 * @interface CartShippingItxDto
 */
export interface CartShippingItxDto {
    /**
     * 
     * @type {number}
     * @memberof CartShippingItxDto
     */
    'sellerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartShippingItxDto
     */
    'idShippingMethod'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartShippingItxDto
     */
    'idBuyerCollectAddress'?: number;
}
/**
 * 
 * @export
 * @interface CategoriesAskForDetails
 */
export interface CategoriesAskForDetails {
    /**
     * 
     * @type {Array<CategoriesAskForDetailsCategoriesInner>}
     * @memberof CategoriesAskForDetails
     */
    'categories'?: Array<CategoriesAskForDetailsCategoriesInner>;
}
/**
 * 
 * @export
 * @interface CategoriesAskForDetailsCategoriesInner
 */
export interface CategoriesAskForDetailsCategoriesInner {
    /**
     * 
     * @type {number}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'title'?: string;
    /**
     * 
     * @type {Array<CategoriesAskForDetailsCategoriesInnerQuestionsInner>}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'questions'?: Array<CategoriesAskForDetailsCategoriesInnerQuestionsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'offerInput'?: PriceItxDto;
    /**
     * 
     * @type {string}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'errorText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoriesAskForDetailsCategoriesInner
     */
    'warningHighPriority'?: boolean;
}
/**
 * 
 * @export
 * @interface CategoriesAskForDetailsCategoriesInnerQuestionsInner
 */
export interface CategoriesAskForDetailsCategoriesInnerQuestionsInner {
    /**
     * 
     * @type {string}
     * @memberof CategoriesAskForDetailsCategoriesInnerQuestionsInner
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoriesAskForDetailsCategoriesInnerQuestionsInner
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'description'?: string;
    /**
     * 
     * @type {Array<Category>}
     * @memberof Category
     */
    'children'?: Array<Category>;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'sizeCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Category
     */
    'selectable'?: boolean;
}
/**
 * 
 * @export
 * @interface ComplaintProductDataDto
 */
export interface ComplaintProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof ComplaintProductDataDto
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ComplaintProductDataDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintProductDataDto
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof ComplaintProductDataDto
     */
    'reasonId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ComplaintProductDataDto
     */
    'reasonIdList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ComplaintProductDataDto
     */
    'additionalInfo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ComplaintProductDataDto
     */
    'legalTermsAccepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComplaintProductDataDto
     */
    'requiredIdentity'?: boolean;
}
/**
 * 
 * @export
 * @interface ComplaintReasonDescriptionDto
 */
export interface ComplaintReasonDescriptionDto {
    /**
     * ISO 639-1 language code
     * @type {string}
     * @memberof ComplaintReasonDescriptionDto
     */
    'languageCode': string;
    /**
     * Entity name
     * @type {string}
     * @memberof ComplaintReasonDescriptionDto
     */
    'name'?: string;
    /**
     * Entity title
     * @type {string}
     * @memberof ComplaintReasonDescriptionDto
     */
    'title'?: string;
    /**
     * Entity description
     * @type {string}
     * @memberof ComplaintReasonDescriptionDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ComplaintReasonItxDto
 */
export interface ComplaintReasonItxDto {
    /**
     * 
     * @type {ComplaintReasonDescriptionDto}
     * @memberof ComplaintReasonItxDto
     */
    'description'?: ComplaintReasonDescriptionDto;
    /**
     * 
     * @type {number}
     * @memberof ComplaintReasonItxDto
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof ComplaintReasonItxDto
     */
    'requiredIdentity'?: boolean;
}
/**
 * 
 * @export
 * @interface ContactInformation
 */
export interface ContactInformation {
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'first_name'?: string;
    /**
     * 
     * @type {object}
     * @memberof ContactInformation
     */
    'middle_name'?: object;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'last_name'?: string;
    /**
     * 
     * @type {object}
     * @memberof ContactInformation
     */
    'honorific'?: object;
    /**
     * 
     * @type {Phone}
     * @memberof ContactInformation
     */
    'phone'?: Phone;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CustomerFavoriteDto
 */
export interface CustomerFavoriteDto {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerFavoriteDto
     */
    'attentionRequired'?: boolean;
}
/**
 * Customer Financial Data for Regulatory Purposes
 * @export
 * @interface CustomerFinancialDataDto
 */
export interface CustomerFinancialDataDto {
    /**
     * ISO code of the country in which this user is residing.
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'residenceCountryISO': string;
    /**
     * ISO code of the country in which this user was born. Mandatory if the country of residence is NOT a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'birthCountryISO'?: string;
    /**
     * Customer\'s full name for regulatory purposes. Mandatory if the country of residence is a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'fullName'?: string;
    /**
     * Customer\'s main address for regulatory purposes. Mandatory if the country of residence is a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'mainAddress'?: string;
    /**
     * Customer\'s document number type. Mandatory if the country of residence is a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'idDocumentType'?: string;
    /**
     * Customer\'s id document number. Mandatory if the country of residence is a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'idDocumentNumber'?: string;
    /**
     * ISO code of the country  id document number. Mandatory if the country of residence is a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'idDocumentExpeditionCountryISO'?: string;
    /**
     * ISO code of the country of issuance of the id document number. Mandatory if the country of residence is a member of the EU
     * @type {string}
     * @memberof CustomerFinancialDataDto
     */
    'dateOfBirth'?: string;
}
/**
 * 
 * @export
 * @interface CustomerItxDataDto
 */
export interface CustomerItxDataDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'inditexId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {RatingsDto}
     * @memberof CustomerItxDataDto
     */
    'ratings'?: RatingsDto;
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'billingAddress'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'returnAddress'?: number;
    /**
     * Customer financial regulation status
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'financialRegulationStatus'?: CustomerItxDataDtoFinancialRegulationStatusEnum;
    /**
     * The id of the ZARA store containing the current user\'s account
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'externalStoreId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'marketIsoCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'totalSales'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerItxDataDto
     */
    'shipmentCompletionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerItxDataDto
     */
    'lastLogin'?: CustomerItxDataDtoLastLoginEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerItxDataDto
     */
    'deletedCustomer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerItxDataDto
     */
    'offersEnabled'?: boolean;
}

export const CustomerItxDataDtoFinancialRegulationStatusEnum = {
    Exempt: 'EXEMPT',
    AdditionalInfoNeeded: 'ADDITIONAL_INFO_NEEDED',
    SellingBlocked: 'SELLING_BLOCKED',
    FinancialInfoComplete: 'FINANCIAL_INFO_COMPLETE'
} as const;

export type CustomerItxDataDtoFinancialRegulationStatusEnum = typeof CustomerItxDataDtoFinancialRegulationStatusEnum[keyof typeof CustomerItxDataDtoFinancialRegulationStatusEnum];
export const CustomerItxDataDtoLastLoginEnum = {
    ThisWeek: 'THIS_WEEK',
    _15DaysAgo: '15_DAYS_AGO',
    _1MonthAgo: '1_MONTH_AGO',
    _3MonthsAgo: '3_MONTHS_AGO',
    MoreThan3MonthsAgo: 'MORE_THAN_3_MONTHS_AGO'
} as const;

export type CustomerItxDataDtoLastLoginEnum = typeof CustomerItxDataDtoLastLoginEnum[keyof typeof CustomerItxDataDtoLastLoginEnum];

/**
 * 
 * @export
 * @interface CustomerNicknameDto
 */
export interface CustomerNicknameDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerNicknameDto
     */
    'nickname'?: string;
}
/**
 * 
 * @export
 * @interface DisputeDataDto
 */
export interface DisputeDataDto {
    /**
     * 
     * @type {string}
     * @memberof DisputeDataDto
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DisputeResolutionType = {
    SellerFavour: 'ON_SELLER_FAVOUR',
    BuyerFavour: 'ON_BUYER_FAVOUR'
} as const;

export type DisputeResolutionType = typeof DisputeResolutionType[keyof typeof DisputeResolutionType];


/**
 * 
 * @export
 * @interface Environment
 */
export interface Environment {
    /**
     * 
     * @type {Array<string>}
     * @memberof Environment
     */
    'activeProfiles'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Environment
     */
    'defaultProfiles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FavoriteIdListDto
 */
export interface FavoriteIdListDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof FavoriteIdListDto
     */
    'productIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface FavoriteItemDto
 */
export interface FavoriteItemDto {
    /**
     * 
     * @type {number}
     * @memberof FavoriteItemDto
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'shortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'colorLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'catalogComposition'?: string;
    /**
     * 
     * @type {number}
     * @memberof FavoriteItemDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItemDto
     */
    'title'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof FavoriteItemDto
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof FavoriteItemDto
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FavoriteItemDto
     */
    'color'?: number;
    /**
     * 
     * @type {number}
     * @memberof FavoriteItemDto
     */
    'condition'?: number;
    /**
     * 
     * @type {ProductState}
     * @memberof FavoriteItemDto
     */
    'productState'?: ProductState;
    /**
     * 
     * @type {Array<string>}
     * @memberof FavoriteItemDto
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FavoriteItemDto
     */
    'manualEntry'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FavoriteItemDto
     */
    'attentionRequired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FavoriteItemDto
     */
    'favorite'?: boolean;
}


/**
 * 
 * @export
 * @interface GeopoliticalSubdivisions
 */
export interface GeopoliticalSubdivisions {
    /**
     * 
     * @type {Level}
     * @memberof GeopoliticalSubdivisions
     */
    'level_1'?: Level;
    /**
     * 
     * @type {Level}
     * @memberof GeopoliticalSubdivisions
     */
    'level_2'?: Level;
    /**
     * 
     * @type {Level}
     * @memberof GeopoliticalSubdivisions
     */
    'level_3'?: Level;
    /**
     * 
     * @type {Level}
     * @memberof GeopoliticalSubdivisions
     */
    'level_4'?: Level;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IncidenceType = {
    DeliveryIncidence: 'DELIVERY_INCIDENCE',
    TransportIncidence: 'TRANSPORT_INCIDENCE',
    Lost: 'LOST',
    CollectionIncidence: 'COLLECTION_INCIDENCE',
    CollectionCanceledOrder: 'COLLECTION_CANCELED_ORDER',
    AddressError: 'ADDRESS_ERROR',
    LabelRequestedError: 'LABEL_REQUESTED_ERROR',
    AddressFraudError: 'ADDRESS_FRAUD_ERROR',
    ZipCodeRestricted: 'ZIP_CODE_RESTRICTED'
} as const;

export type IncidenceType = typeof IncidenceType[keyof typeof IncidenceType];


/**
 * 
 * @export
 * @interface Level
 */
export interface Level {
    /**
     * 
     * @type {Standarized}
     * @memberof Level
     */
    'standarized'?: Standarized;
    /**
     * 
     * @type {object}
     * @memberof Level
     */
    'free_form'?: object;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {object}
     * @memberof Location
     */
    'street_name'?: object;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'street_number'?: string;
    /**
     * 
     * @type {object}
     * @memberof Location
     */
    'floor'?: object;
    /**
     * 
     * @type {object}
     * @memberof Location
     */
    'door'?: object;
}
/**
 * 
 * @export
 * @interface MaxStoreRates
 */
export interface MaxStoreRates {
    /**
     * Highest possible shipping cost
     * @type {number}
     * @memberof MaxStoreRates
     */
    'maxShipping'?: number;
    /**
     * Percentage value of the item value
     * @type {number}
     * @memberof MaxStoreRates
     */
    'maxFee'?: number;
    /**
     * Base fee applied to every purchase
     * @type {number}
     * @memberof MaxStoreRates
     */
    'maxBase'?: number;
}
/**
 * 
 * @export
 * @interface OptionValue
 */
export interface OptionValue {
    /**
     * 
     * @type {number}
     * @memberof OptionValue
     */
    'valueId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OptionValue
     */
    'valueOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof OptionValue
     */
    'valueName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionValue
     */
    'valueDescription'?: string;
}
/**
 * 
 * @export
 * @interface OptionValueSet
 */
export interface OptionValueSet {
    /**
     * 
     * @type {number}
     * @memberof OptionValueSet
     */
    'setId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OptionValueSet
     */
    'optionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OptionValueSet
     */
    'optionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionValueSet
     */
    'optionName'?: string;
    /**
     * 
     * @type {Array<OptionValue>}
     * @memberof OptionValueSet
     */
    'values'?: Array<OptionValue>;
}
/**
 * 
 * @export
 * @interface OrderItemGroupItxDetailDto
 */
export interface OrderItemGroupItxDetailDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDetailDto
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDetailDto
     */
    'expeditionId'?: number;
    /**
     * 
     * @type {Array<SellerOrderItemGroupItxSummaryDto>}
     * @memberof OrderItemGroupItxDetailDto
     */
    'items'?: Array<SellerOrderItemGroupItxSummaryDto>;
    /**
     * 
     * @type {OrderState}
     * @memberof OrderItemGroupItxDetailDto
     */
    'state'?: OrderState;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDetailDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDetailDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDetailDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDetailDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDetailDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {CustomerItxDataDto}
     * @memberof OrderItemGroupItxDetailDto
     */
    'buyer'?: CustomerItxDataDto;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDetailDto
     */
    'customerAddress'?: number;
    /**
     * 
     * @type {ShippingOptionsItxDto}
     * @memberof OrderItemGroupItxDetailDto
     */
    'shippingOptions'?: ShippingOptionsItxDto;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemGroupItxDetailDto
     */
    'expeditionIsCreated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'shippingDateLimit'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'earlyArrivingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'lateArrivingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'boughtDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'shippedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'inTransitDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'incidenceDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'deliveredDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'cancellationDate'?: string;
    /**
     * 
     * @type {CancellationType}
     * @memberof OrderItemGroupItxDetailDto
     */
    'cancellationType'?: CancellationType;
    /**
     * 
     * @type {IncidenceType}
     * @memberof OrderItemGroupItxDetailDto
     */
    'incidenceType'?: IncidenceType;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'trackingUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemGroupItxDetailDto
     */
    'isLost'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'disputeDate'?: string;
    /**
     * 
     * @type {DisputeResolutionType}
     * @memberof OrderItemGroupItxDetailDto
     */
    'disputeResolutionType'?: DisputeResolutionType;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'paidDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'acceptanceDate'?: string;
    /**
     * 
     * @type {RejectionType}
     * @memberof OrderItemGroupItxDetailDto
     */
    'rejectionType'?: RejectionType;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'rejectionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDetailDto
     */
    'dropPointDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemGroupItxDetailDto
     */
    'dropPoint'?: boolean;
}


/**
 * 
 * @export
 * @interface OrderItemGroupItxDto
 */
export interface OrderItemGroupItxDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'sellerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {Set<OrderItemItxDto>}
     * @memberof OrderItemGroupItxDto
     */
    'items'?: Set<OrderItemItxDto>;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDto
     */
    'state'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {RatingsDto}
     * @memberof OrderItemGroupItxDto
     */
    'ratings'?: RatingsDto;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDto
     */
    'sellerCountry'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'shippingMethodId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'shippingMethodTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'buyerAddressId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'totalSales'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupItxDto
     */
    'shipmentCompletionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemGroupItxDto
     */
    'lastLogin'?: OrderItemGroupItxDtoLastLoginEnum;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemGroupItxDto
     */
    'totalTaxes'?: PriceItxDto;
}

export const OrderItemGroupItxDtoLastLoginEnum = {
    ThisWeek: 'THIS_WEEK',
    _15DaysAgo: '15_DAYS_AGO',
    _1MonthAgo: '1_MONTH_AGO',
    _3MonthsAgo: '3_MONTHS_AGO',
    MoreThan3MonthsAgo: 'MORE_THAN_3_MONTHS_AGO'
} as const;

export type OrderItemGroupItxDtoLastLoginEnum = typeof OrderItemGroupItxDtoLastLoginEnum[keyof typeof OrderItemGroupItxDtoLastLoginEnum];

/**
 * 
 * @export
 * @interface OrderItemGroupRatingsDto
 */
export interface OrderItemGroupRatingsDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupRatingsDto
     */
    'productRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupRatingsDto
     */
    'shippingRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemGroupRatingsDto
     */
    'packageRating'?: number;
}
/**
 * 
 * @export
 * @interface OrderItemItxDto
 */
export interface OrderItemItxDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItemItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {OrderProductItxDto}
     * @memberof OrderItemItxDto
     */
    'product'?: OrderProductItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItemItxDto
     */
    'totalTaxes'?: PriceItxDto;
}
/**
 * 
 * @export
 * @interface OrderItemItxSummaryDto
 */
export interface OrderItemItxSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItemItxSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {BuyerOrderProductItxSummaryDto}
     * @memberof OrderItemItxSummaryDto
     */
    'product'?: BuyerOrderProductItxSummaryDto;
}
/**
 * 
 * @export
 * @interface OrderItxDto
 */
export interface OrderItxDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItxDto
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItxDto
     */
    'customerOrderCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItxDto
     */
    'state'?: string;
    /**
     * 
     * @type {Set<OrderItemGroupItxDto>}
     * @memberof OrderItxDto
     */
    'expeditions'?: Set<OrderItemGroupItxDto>;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof OrderItxDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItxDto
     */
    'customerAddress'?: number;
    /**
     * 
     * @type {ShippingOptionsItxDto}
     * @memberof OrderItxDto
     */
    'shippingOptions'?: ShippingOptionsItxDto;
    /**
     * 
     * @type {OrderPaymentStripeDataItxDto}
     * @memberof OrderItxDto
     */
    'orderPaymentStripeDataItxDtos'?: OrderPaymentStripeDataItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'totalTaxes'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'totalWithoutTaxes'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxDto
     */
    'shippingWithoutTaxes'?: PriceItxDto;
}
/**
 * 
 * @export
 * @interface OrderItxItemPreviewSummaryDto
 */
export interface OrderItxItemPreviewSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof OrderItxItemPreviewSummaryDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItxItemPreviewSummaryDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderItxItemPreviewSummaryDto
     */
    'imageUrls'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OrderItxSummaryDto
 */
export interface OrderItxSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof OrderItxSummaryDto
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItxSummaryDto
     */
    'customerOrderCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItxSummaryDto
     */
    'state'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxSummaryDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxSummaryDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxSummaryDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxSummaryDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof OrderItxSummaryDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItxSummaryDto
     */
    'customerAddress'?: number;
    /**
     * 
     * @type {ShippingOptionsItxDto}
     * @memberof OrderItxSummaryDto
     */
    'shippingOptions'?: ShippingOptionsItxDto;
    /**
     * 
     * @type {OrderPaymentStripeDataItxDto}
     * @memberof OrderItxSummaryDto
     */
    'orderPaymentStripeDataItxDtos'?: OrderPaymentStripeDataItxDto;
    /**
     * 
     * @type {Array<BuyerOrderItemGroupSummaryDto>}
     * @memberof OrderItxSummaryDto
     */
    'expeditions'?: Array<BuyerOrderItemGroupSummaryDto>;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderItxSummaryDto
     */
    'totalTaxes'?: PriceItxDto;
}
/**
 * 
 * @export
 * @interface OrderPaymentStripeDataItxDto
 */
export interface OrderPaymentStripeDataItxDto {
    /**
     * 
     * @type {number}
     * @memberof OrderPaymentStripeDataItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentStripeDataItxDto
     */
    'intentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentStripeDataItxDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentStripeDataItxDto
     */
    'clientSecret'?: string;
}
/**
 * 
 * @export
 * @interface OrderProductItxDto
 */
export interface OrderProductItxDto {
    /**
     * 
     * @type {number}
     * @memberof OrderProductItxDto
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderProductItxDto
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProductItxDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProductItxDto
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderProductItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderProductItxDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProductItxDto
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderProductItxDto
     */
    'manualEntry'?: boolean;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof OrderProductItxDto
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {ProductState}
     * @memberof OrderProductItxDto
     */
    'productState'?: ProductState;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderProductItxDto
     */
    'imageUrls'?: Array<string>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderState = {
    PendingPayment: 'PENDING_PAYMENT',
    UnableToComplete: 'UNABLE_TO_COMPLETE',
    ShoppingCartAlreadyComplete: 'SHOPPING_CART_ALREADY_COMPLETE',
    Incidence: 'INCIDENCE',
    PendingShipping: 'PENDING_SHIPPING',
    Sent: 'SENT',
    IncidenceInTransit: 'INCIDENCE_IN_TRANSIT',
    SentAndCharged: 'SENT_AND_CHARGED',
    InTransit: 'IN_TRANSIT',
    InDropPoint: 'IN_DROP_POINT',
    Delivered: 'DELIVERED',
    AutoAccepted: 'AUTO_ACCEPTED',
    Accepted: 'ACCEPTED',
    AutoCancelled: 'AUTO_CANCELLED',
    Cancelled: 'CANCELLED',
    Lost: 'LOST',
    Disputed: 'DISPUTED',
    Reconciled: 'RECONCILED',
    Rejected: 'REJECTED',
    LostReadyToSellerPayment: 'LOST_READY_TO_SELLER_PAYMENT',
    ReadyToSellerPayment: 'READY_TO_SELLER_PAYMENT',
    Paid: 'PAID'
} as const;

export type OrderState = typeof OrderState[keyof typeof OrderState];


/**
 * 
 * @export
 * @interface PageFavoriteItemDto
 */
export interface PageFavoriteItemDto {
    /**
     * 
     * @type {number}
     * @memberof PageFavoriteItemDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageFavoriteItemDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageFavoriteItemDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageFavoriteItemDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageFavoriteItemDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageFavoriteItemDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<FavoriteItemDto>}
     * @memberof PageFavoriteItemDto
     */
    'content'?: Array<FavoriteItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PageFavoriteItemDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageFavoriteItemDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageFavoriteItemDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageFavoriteItemDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageOrderItxSummaryDto
 */
export interface PageOrderItxSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PageOrderItxSummaryDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageOrderItxSummaryDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageOrderItxSummaryDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageOrderItxSummaryDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageOrderItxSummaryDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageOrderItxSummaryDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<OrderItxSummaryDto>}
     * @memberof PageOrderItxSummaryDto
     */
    'content'?: Array<OrderItxSummaryDto>;
    /**
     * 
     * @type {number}
     * @memberof PageOrderItxSummaryDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageOrderItxSummaryDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageOrderItxSummaryDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageOrderItxSummaryDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageProduct
 */
export interface PageProduct {
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageProduct
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageProduct
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProduct
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'size'?: number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof PageProduct
     */
    'content'?: Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageProduct
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageProduct
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageProduct
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageSellerOrderItemGroupSummaryDto
 */
export interface PageSellerOrderItemGroupSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<SellerOrderItemGroupSummaryDto>}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'content'?: Array<SellerOrderItemGroupSummaryDto>;
    /**
     * 
     * @type {number}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageSellerOrderItemGroupSummaryDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageableObject
     */
    'sort'?: Sort;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'number'?: string;
}
/**
 * 
 * @export
 * @interface PriceItxDto
 */
export interface PriceItxDto {
    /**
     * 
     * @type {string}
     * @memberof PriceItxDto
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceItxDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceItxDto
     */
    'exponent'?: number;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'manualEntry'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'lastRejectReason'?: string;
    /**
     * 
     * @type {CustomerItxDataDto}
     * @memberof Product
     */
    'seller'?: CustomerItxDataDto;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'color'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'condition'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'yearOfPurchase'?: number;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof Product
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'customerAddressId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'state'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'pausedByInactivity'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'pausedByInactivityDate'?: string;
}
/**
 * 
 * @export
 * @interface ProductExtended
 */
export interface ProductExtended {
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'catalogDescription'?: string;
    /**
     * 
     * @type {ProductImageItxDto}
     * @memberof ProductExtended
     */
    'frontImage'?: ProductImageItxDto;
    /**
     * 
     * @type {boolean}
     * @memberof ProductExtended
     */
    'manualEntry'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'lastRejectReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'lastRejectReasonTitle'?: string;
    /**
     * 
     * @type {CustomerItxDataDto}
     * @memberof ProductExtended
     */
    'seller'?: CustomerItxDataDto;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'color'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'condition'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductExtended
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'yearOfPurchase'?: number;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ProductExtended
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {Array<ProductImageItxDto>}
     * @memberof ProductExtended
     */
    'imageData'?: Array<ProductImageItxDto>;
    /**
     * 
     * @type {Array<ReasonsDto>}
     * @memberof ProductExtended
     */
    'reasonList'?: Array<ReasonsDto>;
    /**
     * 
     * @type {number}
     * @memberof ProductExtended
     */
    'customerAddressId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductExtended
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface ProductIdsDto
 */
export interface ProductIdsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductIdsDto
     */
    'ids': Array<number>;
}
/**
 * 
 * @export
 * @interface ProductImageItxDto
 */
export interface ProductImageItxDto {
    /**
     * 
     * @type {string}
     * @memberof ProductImageItxDto
     */
    'assetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductImageItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductImageItxDto
     */
    'amandaId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductImageItxDto
     */
    'deliveryUrl'?: string;
}
/**
 * 
 * @export
 * @interface ProductInput
 */
export interface ProductInput {
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'catalogId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'color'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductInput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductInput
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'condition'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductInput
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductInput
     */
    'yearOfPurchase'?: number;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ProductInput
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {Array<ProductImageItxDto>}
     * @memberof ProductInput
     */
    'imageUrls'?: Array<ProductImageItxDto>;
    /**
     * 
     * @type {string}
     * @memberof ProductInput
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProductState = {
    AmandaProcessing: 'AMANDA_PROCESSING',
    PendingReview: 'PENDING_REVIEW',
    InReview: 'IN_REVIEW',
    AmandaProcessingGrid: 'AMANDA_PROCESSING_GRID',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    PausedAmandaProcessing: 'PAUSED_AMANDA_PROCESSING',
    PausedPendingReview: 'PAUSED_PENDING_REVIEW',
    Sold: 'SOLD',
    Rejected: 'REJECTED',
    Deleted: 'DELETED',
    Disputed: 'DISPUTED',
    PendingEvaluationAi: 'PENDING_EVALUATION_AI',
    PausedPendingEvaluationAi: 'PAUSED_PENDING_EVALUATION_AI'
} as const;

export type ProductState = typeof ProductState[keyof typeof ProductState];


/**
 * 
 * @export
 * @interface ProductStateCountDto
 */
export interface ProductStateCountDto {
    /**
     * 
     * @type {string}
     * @memberof ProductStateCountDto
     */
    'state'?: ProductStateCountDtoStateEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductStateCountDto
     */
    'count'?: number;
}

export const ProductStateCountDtoStateEnum = {
    AmandaProcessing: 'AMANDA_PROCESSING',
    PendingReview: 'PENDING_REVIEW',
    InReview: 'IN_REVIEW',
    AmandaProcessingGrid: 'AMANDA_PROCESSING_GRID',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    PausedAmandaProcessing: 'PAUSED_AMANDA_PROCESSING',
    PausedPendingReview: 'PAUSED_PENDING_REVIEW',
    Sold: 'SOLD',
    Rejected: 'REJECTED',
    Deleted: 'DELETED',
    Disputed: 'DISPUTED',
    PendingEvaluationAi: 'PENDING_EVALUATION_AI',
    PausedPendingEvaluationAi: 'PAUSED_PENDING_EVALUATION_AI'
} as const;

export type ProductStateCountDtoStateEnum = typeof ProductStateCountDtoStateEnum[keyof typeof ProductStateCountDtoStateEnum];

/**
 * 
 * @export
 * @interface ProductStateDto
 */
export interface ProductStateDto {
    /**
     * 
     * @type {Array<ProductStateCountDto>}
     * @memberof ProductStateDto
     */
    'stateCount'?: Array<ProductStateCountDto>;
    /**
     * 
     * @type {number}
     * @memberof ProductStateDto
     */
    'pausableCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductStateDto
     */
    'resumableCount'?: number;
}
/**
 * 
 * @export
 * @interface RatingsDto
 */
export interface RatingsDto {
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'productRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'sellerRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'shippingRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'autoRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'totalRatings'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatingsDto
     */
    'totalAutoRatings'?: number;
}
/**
 * 
 * @export
 * @interface ReasonsDto
 */
export interface ReasonsDto {
    /**
     * 
     * @type {string}
     * @memberof ReasonsDto
     */
    'lastRejectReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReasonsDto
     */
    'lastRejectReasonTitle'?: string;
}
/**
 * 
 * @export
 * @interface RedirectView
 */
export interface RedirectView {
    /**
     * 
     * @type {ApplicationContext}
     * @memberof RedirectView
     */
    'applicationContext'?: ApplicationContext;
    /**
     * 
     * @type {RedirectViewServletContext}
     * @memberof RedirectView
     */
    'servletContext'?: RedirectViewServletContext;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'requestContextAttribute'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof RedirectView
     */
    'staticAttributes'?: { [key: string]: object; };
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'exposePathVariables'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'exposeContextBeansAsAttributes'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectView
     */
    'exposedContextBeanNames'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'beanName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'contextRelative'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'http10Compatible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'exposeModelAttributes'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'encodingScheme'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'statusCode'?: RedirectViewStatusCodeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'expandUriTemplateVariables'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'propagateQueryParams'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectView
     */
    'hosts'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'redirectView'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    'propagateQueryProperties'?: boolean;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof RedirectView
     */
    'attributesMap'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    'attributesCSV'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RedirectView
     */
    'attributes'?: { [key: string]: string; };
}

export const RedirectViewStatusCodeEnum = {
    _100Continue: '100 CONTINUE',
    _101SwitchingProtocols: '101 SWITCHING_PROTOCOLS',
    _102Processing: '102 PROCESSING',
    _103Checkpoint: '103 CHECKPOINT',
    _200Ok: '200 OK',
    _201Created: '201 CREATED',
    _202Accepted: '202 ACCEPTED',
    _203NonAuthoritativeInformation: '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent: '204 NO_CONTENT',
    _205ResetContent: '205 RESET_CONTENT',
    _206PartialContent: '206 PARTIAL_CONTENT',
    _207MultiStatus: '207 MULTI_STATUS',
    _208AlreadyReported: '208 ALREADY_REPORTED',
    _226ImUsed: '226 IM_USED',
    _300MultipleChoices: '300 MULTIPLE_CHOICES',
    _301MovedPermanently: '301 MOVED_PERMANENTLY',
    _302Found: '302 FOUND',
    _302MovedTemporarily: '302 MOVED_TEMPORARILY',
    _303SeeOther: '303 SEE_OTHER',
    _304NotModified: '304 NOT_MODIFIED',
    _305UseProxy: '305 USE_PROXY',
    _307TemporaryRedirect: '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect: '308 PERMANENT_REDIRECT',
    _400BadRequest: '400 BAD_REQUEST',
    _401Unauthorized: '401 UNAUTHORIZED',
    _402PaymentRequired: '402 PAYMENT_REQUIRED',
    _403Forbidden: '403 FORBIDDEN',
    _404NotFound: '404 NOT_FOUND',
    _405MethodNotAllowed: '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable: '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired: '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout: '408 REQUEST_TIMEOUT',
    _409Conflict: '409 CONFLICT',
    _410Gone: '410 GONE',
    _411LengthRequired: '411 LENGTH_REQUIRED',
    _412PreconditionFailed: '412 PRECONDITION_FAILED',
    _413PayloadTooLarge: '413 PAYLOAD_TOO_LARGE',
    _413RequestEntityTooLarge: '413 REQUEST_ENTITY_TOO_LARGE',
    _414UriTooLong: '414 URI_TOO_LONG',
    _414RequestUriTooLong: '414 REQUEST_URI_TOO_LONG',
    _415UnsupportedMediaType: '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable: '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed: '417 EXPECTATION_FAILED',
    _418IAmATeapot: '418 I_AM_A_TEAPOT',
    _419InsufficientSpaceOnResource: '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420MethodFailure: '420 METHOD_FAILURE',
    _421DestinationLocked: '421 DESTINATION_LOCKED',
    _422UnprocessableEntity: '422 UNPROCESSABLE_ENTITY',
    _423Locked: '423 LOCKED',
    _424FailedDependency: '424 FAILED_DEPENDENCY',
    _425TooEarly: '425 TOO_EARLY',
    _426UpgradeRequired: '426 UPGRADE_REQUIRED',
    _428PreconditionRequired: '428 PRECONDITION_REQUIRED',
    _429TooManyRequests: '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge: '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons: '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError: '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented: '501 NOT_IMPLEMENTED',
    _502BadGateway: '502 BAD_GATEWAY',
    _503ServiceUnavailable: '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout: '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported: '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates: '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage: '507 INSUFFICIENT_STORAGE',
    _508LoopDetected: '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded: '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended: '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired: '511 NETWORK_AUTHENTICATION_REQUIRED'
} as const;

export type RedirectViewStatusCodeEnum = typeof RedirectViewStatusCodeEnum[keyof typeof RedirectViewStatusCodeEnum];

/**
 * 
 * @export
 * @interface RedirectViewServletContext
 */
export interface RedirectViewServletContext {
    /**
     * 
     * @type {Set<string>}
     * @memberof RedirectViewServletContext
     */
    'sessionTrackingModes'?: Set<RedirectViewServletContextSessionTrackingModesEnum>;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleClassLoader}
     * @memberof RedirectViewServletContext
     */
    'classLoader'?: ApplicationContextClassLoaderParentUnnamedModuleClassLoader;
    /**
     * 
     * @type {number}
     * @memberof RedirectViewServletContext
     */
    'majorVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof RedirectViewServletContext
     */
    'minorVersion'?: number;
    /**
     * 
     * @type {object}
     * @memberof RedirectViewServletContext
     */
    'attributeNames'?: object;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContext
     */
    'contextPath'?: string;
    /**
     * 
     * @type {object}
     * @memberof RedirectViewServletContext
     */
    'initParameterNames'?: object;
    /**
     * 
     * @type {number}
     * @memberof RedirectViewServletContext
     */
    'sessionTimeout'?: number;
    /**
     * 
     * @type {object}
     * @memberof RedirectViewServletContext
     * @deprecated
     */
    'servletNames'?: object;
    /**
     * 
     * @type {{ [key: string]: RedirectViewServletContextServletRegistrationsValue; }}
     * @memberof RedirectViewServletContext
     */
    'servletRegistrations'?: { [key: string]: RedirectViewServletContextServletRegistrationsValue; };
    /**
     * 
     * @type {{ [key: string]: RedirectViewServletContextFilterRegistrationsValue; }}
     * @memberof RedirectViewServletContext
     */
    'filterRegistrations'?: { [key: string]: RedirectViewServletContextFilterRegistrationsValue; };
    /**
     * 
     * @type {RedirectViewServletContextSessionCookieConfig}
     * @memberof RedirectViewServletContext
     */
    'sessionCookieConfig'?: RedirectViewServletContextSessionCookieConfig;
    /**
     * 
     * @type {Set<string>}
     * @memberof RedirectViewServletContext
     */
    'defaultSessionTrackingModes'?: Set<RedirectViewServletContextDefaultSessionTrackingModesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof RedirectViewServletContext
     */
    'effectiveSessionTrackingModes'?: Set<RedirectViewServletContextEffectiveSessionTrackingModesEnum>;
    /**
     * 
     * @type {RedirectViewServletContextJspConfigDescriptor}
     * @memberof RedirectViewServletContext
     */
    'jspConfigDescriptor'?: RedirectViewServletContextJspConfigDescriptor;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContext
     */
    'virtualServerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContext
     */
    'requestCharacterEncoding'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContext
     */
    'responseCharacterEncoding'?: string;
    /**
     * 
     * @type {number}
     * @memberof RedirectViewServletContext
     */
    'effectiveMajorVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof RedirectViewServletContext
     */
    'effectiveMinorVersion'?: number;
    /**
     * 
     * @type {object}
     * @memberof RedirectViewServletContext
     * @deprecated
     */
    'servlets'?: object;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContext
     */
    'serverInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContext
     */
    'servletContextName'?: string;
}

export const RedirectViewServletContextSessionTrackingModesEnum = {
    Cookie: 'COOKIE',
    Url: 'URL',
    Ssl: 'SSL'
} as const;

export type RedirectViewServletContextSessionTrackingModesEnum = typeof RedirectViewServletContextSessionTrackingModesEnum[keyof typeof RedirectViewServletContextSessionTrackingModesEnum];
export const RedirectViewServletContextDefaultSessionTrackingModesEnum = {
    Cookie: 'COOKIE',
    Url: 'URL',
    Ssl: 'SSL'
} as const;

export type RedirectViewServletContextDefaultSessionTrackingModesEnum = typeof RedirectViewServletContextDefaultSessionTrackingModesEnum[keyof typeof RedirectViewServletContextDefaultSessionTrackingModesEnum];
export const RedirectViewServletContextEffectiveSessionTrackingModesEnum = {
    Cookie: 'COOKIE',
    Url: 'URL',
    Ssl: 'SSL'
} as const;

export type RedirectViewServletContextEffectiveSessionTrackingModesEnum = typeof RedirectViewServletContextEffectiveSessionTrackingModesEnum[keyof typeof RedirectViewServletContextEffectiveSessionTrackingModesEnum];

/**
 * 
 * @export
 * @interface RedirectViewServletContextFilterRegistrationsValue
 */
export interface RedirectViewServletContextFilterRegistrationsValue {
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectViewServletContextFilterRegistrationsValue
     */
    'servletNameMappings'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectViewServletContextFilterRegistrationsValue
     */
    'urlPatternMappings'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RedirectViewServletContextFilterRegistrationsValue
     */
    'initParameters'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextFilterRegistrationsValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextFilterRegistrationsValue
     */
    'className'?: string;
}
/**
 * 
 * @export
 * @interface RedirectViewServletContextJspConfigDescriptor
 */
export interface RedirectViewServletContextJspConfigDescriptor {
    /**
     * 
     * @type {Array<RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner>}
     * @memberof RedirectViewServletContextJspConfigDescriptor
     */
    'jspPropertyGroups'?: Array<RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner>;
    /**
     * 
     * @type {Array<RedirectViewServletContextJspConfigDescriptorTaglibsInner>}
     * @memberof RedirectViewServletContextJspConfigDescriptor
     */
    'taglibs'?: Array<RedirectViewServletContextJspConfigDescriptorTaglibsInner>;
}
/**
 * 
 * @export
 * @interface RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
 */
export interface RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner {
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'elIgnored'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'scriptingInvalid'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'pageEncoding'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'isXml'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'includePreludes'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'includeCodas'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'deferredSyntaxAllowedAsLiteral'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'trimDirectiveWhitespaces'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'errorOnUndeclaredNamespace'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'defaultContentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'buffer'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectViewServletContextJspConfigDescriptorJspPropertyGroupsInner
     */
    'urlPatterns'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RedirectViewServletContextJspConfigDescriptorTaglibsInner
 */
export interface RedirectViewServletContextJspConfigDescriptorTaglibsInner {
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorTaglibsInner
     */
    'taglibLocation'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextJspConfigDescriptorTaglibsInner
     */
    'taglibURI'?: string;
}
/**
 * 
 * @export
 * @interface RedirectViewServletContextServletRegistrationsValue
 */
export interface RedirectViewServletContextServletRegistrationsValue {
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextServletRegistrationsValue
     */
    'runAsRole'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectViewServletContextServletRegistrationsValue
     */
    'mappings'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RedirectViewServletContextServletRegistrationsValue
     */
    'initParameters'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextServletRegistrationsValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextServletRegistrationsValue
     */
    'className'?: string;
}
/**
 * 
 * @export
 * @interface RedirectViewServletContextSessionCookieConfig
 */
export interface RedirectViewServletContextSessionCookieConfig {
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'comment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'secure'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'domain'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'httpOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RedirectViewServletContextSessionCookieConfig
     */
    'maxAge'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RejectionType = {
    Incidence: 'INCIDENCE',
    Dispute: 'DISPUTE',
    Lost: 'LOST'
} as const;

export type RejectionType = typeof RejectionType[keyof typeof RejectionType];


/**
 * 
 * @export
 * @interface SellerOrderItemGroupItxSummaryDto
 */
export interface SellerOrderItemGroupItxSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof SellerOrderItemGroupItxSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {SellerOrderProductItxSummaryDto}
     * @memberof SellerOrderItemGroupItxSummaryDto
     */
    'product'?: SellerOrderProductItxSummaryDto;
}
/**
 * 
 * @export
 * @interface SellerOrderItemGroupSummaryDto
 */
export interface SellerOrderItemGroupSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'expeditionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'customerOrderCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'buyerId'?: number;
    /**
     * 
     * @type {Array<OrderItxItemPreviewSummaryDto>}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'items'?: Array<OrderItxItemPreviewSummaryDto>;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'state'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'customerAddress'?: number;
    /**
     * 
     * @type {ShippingOptionsItxDto}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'shippingOptions'?: ShippingOptionsItxDto;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'shippingDateLimit'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'attentionRequired'?: boolean;
    /**
     * 
     * @type {IncidenceType}
     * @memberof SellerOrderItemGroupSummaryDto
     */
    'incidenceType'?: IncidenceType;
}


/**
 * 
 * @export
 * @interface SellerOrderProductItxSummaryDto
 */
export interface SellerOrderProductItxSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'title'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {ProductState}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'productState'?: ProductState;
    /**
     * 
     * @type {Array<string>}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'conditionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'colorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'sizeId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SellerOrderProductItxSummaryDto
     */
    'manualEntry'?: boolean;
}


/**
 * 
 * @export
 * @interface ShippingMethodItxDto
 */
export interface ShippingMethodItxDto {
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodItxDto
     */
    'idShippingMethod'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodItxDto
     */
    'maxDelayDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodItxDto
     */
    'minDelayDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodItxDto
     */
    'countryArrive'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodItxDto
     */
    'countryDeparture'?: string;
    /**
     * 
     * @type {ShippingMethodTypeItxDto}
     * @memberof ShippingMethodItxDto
     */
    'shippingMethodType'?: ShippingMethodTypeItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShippingMethodItxDto
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodItxDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodItxDto
     */
    'shippingOption'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingMethodItxDto
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodItxDto
     */
    'merchant'?: number;
}
/**
 * 
 * @export
 * @interface ShippingMethodTypeItxDto
 */
export interface ShippingMethodTypeItxDto {
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodTypeItxDto
     */
    'idShippingMethod'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodTypeItxDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingMethodTypeItxDto
     */
    'enable'?: boolean;
}
/**
 * 
 * @export
 * @interface ShippingOptionsItxDto
 */
export interface ShippingOptionsItxDto {
    /**
     * 
     * @type {number}
     * @memberof ShippingOptionsItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingOptionsItxDto
     */
    'shippingOptionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingOptionsItxDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingOptionsItxDto
     */
    'description'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShippingOptionsItxDto
     */
    'price'?: PriceItxDto;
}
/**
 * 
 * @export
 * @interface ShoppingCartItemItxDto
 */
export interface ShoppingCartItemItxDto {
    /**
     * 
     * @type {ShoppingCartProductItxDto}
     * @memberof ShoppingCartItemItxDto
     */
    'productItx'?: ShoppingCartProductItxDto;
    /**
     * 
     * @type {boolean}
     * @memberof ShoppingCartItemItxDto
     */
    'hasChanged'?: boolean;
}
/**
 * 
 * @export
 * @interface ShoppingCartItxDto
 */
export interface ShoppingCartItxDto {
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartItxDto
     */
    'shoppingCartCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItxDto
     */
    'customerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItxDto
     */
    'customerAddress'?: number;
    /**
     * 
     * @type {Set<ShoppingCartSellerItemGroupItxDto>}
     * @memberof ShoppingCartItxDto
     */
    'shoppingCartSellerItemGroupItxes'?: Set<ShoppingCartSellerItemGroupItxDto>;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartItxDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartItxDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartItxDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartItxDto
     */
    'finalTotalWithoutShipping'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartItxDto
     */
    'totalTaxes'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartItxDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItxDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItxDto
     */
    'shippingMethodId'?: number;
}
/**
 * 
 * @export
 * @interface ShoppingCartProductItxDto
 */
export interface ShoppingCartProductItxDto {
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartProductItxDto
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartProductItxDto
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartProductItxDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartProductItxDto
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartProductItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartProductItxDto
     */
    'title'?: string;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartProductItxDto
     */
    'price'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartProductItxDto
     */
    'offerPrice'?: PriceItxDto;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartProductItxDto
     */
    'offerExpireDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartProductItxDto
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartProductItxDto
     */
    'color'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartProductItxDto
     */
    'condition'?: number;
    /**
     * 
     * @type {ProductState}
     * @memberof ShoppingCartProductItxDto
     */
    'productState'?: ProductState;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoppingCartProductItxDto
     */
    'imageUrls'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ShoppingCartProductItxDto
     */
    'manualEntry'?: boolean;
    /**
     * Grid ids
     * @type {Array<string>}
     * @memberof ShoppingCartProductItxDto
     */
    'grids'?: Array<string>;
    /**
     * Universe ids
     * @type {Array<string>}
     * @memberof ShoppingCartProductItxDto
     */
    'universes'?: Array<string>;
}


/**
 * 
 * @export
 * @interface ShoppingCartSellerItemGroupItxDto
 */
export interface ShoppingCartSellerItemGroupItxDto {
    /**
     * 
     * @type {Set<ShoppingCartItemItxDto>}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'items'?: Set<ShoppingCartItemItxDto>;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'itemsTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'feesTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'shippingTotal'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'finalTotalWithoutShipping'?: PriceItxDto;
    /**
     * 
     * @type {PriceItxDto}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'finalTotal'?: PriceItxDto;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'sellerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'sellerCountry'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'deliveryAddress'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {RatingsDto}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'ratings'?: RatingsDto;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'totalSales'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'shipmentCompletionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartSellerItemGroupItxDto
     */
    'lastLogin'?: ShoppingCartSellerItemGroupItxDtoLastLoginEnum;
}

export const ShoppingCartSellerItemGroupItxDtoLastLoginEnum = {
    ThisWeek: 'THIS_WEEK',
    _15DaysAgo: '15_DAYS_AGO',
    _1MonthAgo: '1_MONTH_AGO',
    _3MonthsAgo: '3_MONTHS_AGO',
    MoreThan3MonthsAgo: 'MORE_THAN_3_MONTHS_AGO'
} as const;

export type ShoppingCartSellerItemGroupItxDtoLastLoginEnum = typeof ShoppingCartSellerItemGroupItxDtoLastLoginEnum[keyof typeof ShoppingCartSellerItemGroupItxDtoLastLoginEnum];

/**
 * 
 * @export
 * @interface Sort
 */
export interface Sort {
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'unsorted'?: boolean;
}
/**
 * 
 * @export
 * @interface Standarized
 */
export interface Standarized {
    /**
     * 
     * @type {string}
     * @memberof Standarized
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Standarized
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface StripeDashboardLoginLinkDto
 */
export interface StripeDashboardLoginLinkDto {
    /**
     * 
     * @type {string}
     * @memberof StripeDashboardLoginLinkDto
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof StripeDashboardLoginLinkDto
     */
    'created'?: number;
    /**
     * 
     * @type {string}
     * @memberof StripeDashboardLoginLinkDto
     */
    'object'?: string;
}
/**
 * 
 * @export
 * @interface StripeOnboardingLinkDto
 */
export interface StripeOnboardingLinkDto {
    /**
     * 
     * @type {string}
     * @memberof StripeOnboardingLinkDto
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof StripeOnboardingLinkDto
     */
    'created'?: number;
    /**
     * 
     * @type {number}
     * @memberof StripeOnboardingLinkDto
     */
    'expiresAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof StripeOnboardingLinkDto
     */
    'object'?: string;
}

/**
 * AmandaServiceManagementAPIApi - axios parameter creator
 * @export
 */
export const AmandaServiceManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Image data by AssetId v1
         * @param {string} assetId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageDataV1: async (assetId: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getImageDataV1', 'assetId', assetId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getImageDataV1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/amanda/data/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Image data by AssetId v2
         * @param {string} assetId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageDataV2: async (assetId: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getImageDataV2', 'assetId', assetId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getImageDataV2', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/amanda/data/v2/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmandaServiceManagementAPIApi - functional programming interface
 * @export
 */
export const AmandaServiceManagementAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AmandaServiceManagementAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Image data by AssetId v1
         * @param {string} assetId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageDataV1(assetId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmandaImageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageDataV1(assetId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Image data by AssetId v2
         * @param {string} assetId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageDataV2(assetId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmandaImageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageDataV2(assetId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AmandaServiceManagementAPIApi - factory interface
 * @export
 */
export const AmandaServiceManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AmandaServiceManagementAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Image data by AssetId v1
         * @param {string} assetId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageDataV1(assetId: string, storeId: number, lang?: string, options?: any): AxiosPromise<AmandaImageDto> {
            return localVarFp.getImageDataV1(assetId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Image data by AssetId v2
         * @param {string} assetId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageDataV2(assetId: string, storeId: number, lang?: string, options?: any): AxiosPromise<AmandaImageDto> {
            return localVarFp.getImageDataV2(assetId, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AmandaServiceManagementAPIApi - interface
 * @export
 * @interface AmandaServiceManagementAPIApi
 */
export interface AmandaServiceManagementAPIApiInterface {
    /**
     * 
     * @summary Get Image data by AssetId v1
     * @param {string} assetId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmandaServiceManagementAPIApiInterface
     */
    getImageDataV1(assetId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<AmandaImageDto>;

    /**
     * 
     * @summary Get Image data by AssetId v2
     * @param {string} assetId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmandaServiceManagementAPIApiInterface
     */
    getImageDataV2(assetId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<AmandaImageDto>;

}

/**
 * AmandaServiceManagementAPIApi - object-oriented interface
 * @export
 * @class AmandaServiceManagementAPIApi
 * @extends {BaseAPI}
 */
export class AmandaServiceManagementAPIApi extends BaseAPI implements AmandaServiceManagementAPIApiInterface {
    /**
     * 
     * @summary Get Image data by AssetId v1
     * @param {string} assetId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmandaServiceManagementAPIApi
     */
    public getImageDataV1(assetId: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return AmandaServiceManagementAPIApiFp(this.configuration).getImageDataV1(assetId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Image data by AssetId v2
     * @param {string} assetId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmandaServiceManagementAPIApi
     */
    public getImageDataV2(assetId: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return AmandaServiceManagementAPIApiFp(this.configuration).getImageDataV2(assetId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AskForProductDetailsApi - axios parameter creator
 * @export
 */
export const AskForProductDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get categories and subcategories for ask for product details
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [productId] Product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAskForDetails: async (storeId: number, lang?: string, productId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getAskForDetails', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/ask-for-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AskForProductDetailsApi - functional programming interface
 * @export
 */
export const AskForProductDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AskForProductDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get categories and subcategories for ask for product details
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [productId] Product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAskForDetails(storeId: number, lang?: string, productId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesAskForDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAskForDetails(storeId, lang, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AskForProductDetailsApi - factory interface
 * @export
 */
export const AskForProductDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AskForProductDetailsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get categories and subcategories for ask for product details
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [productId] Product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAskForDetails(storeId: number, lang?: string, productId?: number, options?: any): AxiosPromise<CategoriesAskForDetails> {
            return localVarFp.getAskForDetails(storeId, lang, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AskForProductDetailsApi - interface
 * @export
 * @interface AskForProductDetailsApi
 */
export interface AskForProductDetailsApiInterface {
    /**
     * 
     * @summary Get categories and subcategories for ask for product details
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [productId] Product id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskForProductDetailsApiInterface
     */
    getAskForDetails(storeId: number, lang?: string, productId?: number, options?: AxiosRequestConfig): AxiosPromise<CategoriesAskForDetails>;

}

/**
 * AskForProductDetailsApi - object-oriented interface
 * @export
 * @class AskForProductDetailsApi
 * @extends {BaseAPI}
 */
export class AskForProductDetailsApi extends BaseAPI implements AskForProductDetailsApiInterface {
    /**
     * 
     * @summary Get categories and subcategories for ask for product details
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [productId] Product id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskForProductDetailsApi
     */
    public getAskForDetails(storeId: number, lang?: string, productId?: number, options?: AxiosRequestConfig) {
        return AskForProductDetailsApiFp(this.configuration).getAskForDetails(storeId, lang, productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyerFavoritesApiApi - axios parameter creator
 * @export
 */
export const BuyerFavoritesApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add the specified product to current customer\'s favorites list
         * @param {number} storeId ID of the store this query is directed to
         * @param {FavoriteIdListDto} favoriteIdListDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteProduct: async (storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addFavoriteProduct', 'storeId', storeId)
            // verify required parameter 'favoriteIdListDto' is not null or undefined
            assertParamExists('addFavoriteProduct', 'favoriteIdListDto', favoriteIdListDto)
            const localVarPath = `/api/v1/customer/buyer/favorites/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteIdListDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark this favorite product as viewed and remove its attention required flag
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteProductViewed: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoriteProductViewed', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('favoriteProductViewed', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites/{id}/viewed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark current user attention required flag as viewed in customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteUserViewed: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('favoriteUserViewed', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites/customer/viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary If this product is a favorite, get its details. Return 404 if the product is not a favorite.
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteProduct: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFavoriteProduct', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getFavoriteProduct', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets current user attention required flag
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteProduct1: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getFavoriteProduct1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List favorite products for the current customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFavoriteProducts: async (storeId: number, page?: number, count?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listFavoriteProducts', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark this favorite product as viewed and remove its attention required flag
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteProductViewed: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postFavoriteProductViewed', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postFavoriteProductViewed', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites/{id}/viewed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark current user attention required flag as viewed in customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteUserViewed: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postFavoriteUserViewed', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/favorites/customer/viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove the specified products from current customer\'s favorites list
         * @param {number} storeId ID of the store this query is directed to
         * @param {FavoriteIdListDto} favoriteIdListDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavoriteProduct: async (storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('removeFavoriteProduct', 'storeId', storeId)
            // verify required parameter 'favoriteIdListDto' is not null or undefined
            assertParamExists('removeFavoriteProduct', 'favoriteIdListDto', favoriteIdListDto)
            const localVarPath = `/api/v1/customer/buyer/favorites/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteIdListDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerFavoritesApiApi - functional programming interface
 * @export
 */
export const BuyerFavoritesApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerFavoritesApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add the specified product to current customer\'s favorites list
         * @param {number} storeId ID of the store this query is directed to
         * @param {FavoriteIdListDto} favoriteIdListDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FavoriteItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFavoriteProduct(storeId, favoriteIdListDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark this favorite product as viewed and remove its attention required flag
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteProductViewed(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteProductViewed(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark current user attention required flag as viewed in customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteUserViewed(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteUserViewed(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary If this product is a favorite, get its details. Return 404 if the product is not a favorite.
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteProduct(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoriteProduct(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets current user attention required flag
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteProduct1(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerFavoriteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoriteProduct1(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List favorite products for the current customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFavoriteProducts(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageFavoriteItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFavoriteProducts(storeId, page, count, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark this favorite product as viewed and remove its attention required flag
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFavoriteProductViewed(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFavoriteProductViewed(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark current user attention required flag as viewed in customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFavoriteUserViewed(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFavoriteUserViewed(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove the specified products from current customer\'s favorites list
         * @param {number} storeId ID of the store this query is directed to
         * @param {FavoriteIdListDto} favoriteIdListDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFavoriteProduct(storeId, favoriteIdListDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyerFavoritesApiApi - factory interface
 * @export
 */
export const BuyerFavoritesApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerFavoritesApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Add the specified product to current customer\'s favorites list
         * @param {number} storeId ID of the store this query is directed to
         * @param {FavoriteIdListDto} favoriteIdListDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: any): AxiosPromise<Array<FavoriteItemDto>> {
            return localVarFp.addFavoriteProduct(storeId, favoriteIdListDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark this favorite product as viewed and remove its attention required flag
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteProductViewed(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<FavoriteItemDto> {
            return localVarFp.favoriteProductViewed(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark current user attention required flag as viewed in customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteUserViewed(storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.favoriteUserViewed(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary If this product is a favorite, get its details. Return 404 if the product is not a favorite.
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteProduct(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<FavoriteItemDto> {
            return localVarFp.getFavoriteProduct(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets current user attention required flag
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteProduct1(storeId: number, lang?: string, options?: any): AxiosPromise<CustomerFavoriteDto> {
            return localVarFp.getFavoriteProduct1(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List favorite products for the current customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFavoriteProducts(storeId: number, page?: number, count?: number, lang?: string, options?: any): AxiosPromise<PageFavoriteItemDto> {
            return localVarFp.listFavoriteProducts(storeId, page, count, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark this favorite product as viewed and remove its attention required flag
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteProductViewed(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<FavoriteItemDto> {
            return localVarFp.postFavoriteProductViewed(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark current user attention required flag as viewed in customer
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteUserViewed(storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.postFavoriteUserViewed(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove the specified products from current customer\'s favorites list
         * @param {number} storeId ID of the store this query is directed to
         * @param {FavoriteIdListDto} favoriteIdListDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeFavoriteProduct(storeId, favoriteIdListDto, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerFavoritesApiApi - interface
 * @export
 * @interface BuyerFavoritesApiApi
 */
export interface BuyerFavoritesApiApiInterface {
    /**
     * 
     * @summary Add the specified product to current customer\'s favorites list
     * @param {number} storeId ID of the store this query is directed to
     * @param {FavoriteIdListDto} favoriteIdListDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    addFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<FavoriteItemDto>>;

    /**
     * 
     * @summary Mark this favorite product as viewed and remove its attention required flag
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    favoriteProductViewed(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<FavoriteItemDto>;

    /**
     * 
     * @summary Mark current user attention required flag as viewed in customer
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    favoriteUserViewed(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary If this product is a favorite, get its details. Return 404 if the product is not a favorite.
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    getFavoriteProduct(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<FavoriteItemDto>;

    /**
     * 
     * @summary Gets current user attention required flag
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    getFavoriteProduct1(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerFavoriteDto>;

    /**
     * 
     * @summary List favorite products for the current customer
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    listFavoriteProducts(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageFavoriteItemDto>;

    /**
     * 
     * @summary Mark this favorite product as viewed and remove its attention required flag
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    postFavoriteProductViewed(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<FavoriteItemDto>;

    /**
     * 
     * @summary Mark current user attention required flag as viewed in customer
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    postFavoriteUserViewed(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Remove the specified products from current customer\'s favorites list
     * @param {number} storeId ID of the store this query is directed to
     * @param {FavoriteIdListDto} favoriteIdListDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApiInterface
     */
    removeFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * BuyerFavoritesApiApi - object-oriented interface
 * @export
 * @class BuyerFavoritesApiApi
 * @extends {BaseAPI}
 */
export class BuyerFavoritesApiApi extends BaseAPI implements BuyerFavoritesApiApiInterface {
    /**
     * 
     * @summary Add the specified product to current customer\'s favorites list
     * @param {number} storeId ID of the store this query is directed to
     * @param {FavoriteIdListDto} favoriteIdListDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public addFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).addFavoriteProduct(storeId, favoriteIdListDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark this favorite product as viewed and remove its attention required flag
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public favoriteProductViewed(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).favoriteProductViewed(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark current user attention required flag as viewed in customer
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public favoriteUserViewed(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).favoriteUserViewed(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary If this product is a favorite, get its details. Return 404 if the product is not a favorite.
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public getFavoriteProduct(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).getFavoriteProduct(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets current user attention required flag
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public getFavoriteProduct1(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).getFavoriteProduct1(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List favorite products for the current customer
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public listFavoriteProducts(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).listFavoriteProducts(storeId, page, count, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark this favorite product as viewed and remove its attention required flag
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public postFavoriteProductViewed(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).postFavoriteProductViewed(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark current user attention required flag as viewed in customer
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public postFavoriteUserViewed(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).postFavoriteUserViewed(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove the specified products from current customer\'s favorites list
     * @param {number} storeId ID of the store this query is directed to
     * @param {FavoriteIdListDto} favoriteIdListDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerFavoritesApiApi
     */
    public removeFavoriteProduct(storeId: number, favoriteIdListDto: FavoriteIdListDto, lang?: string, options?: AxiosRequestConfig) {
        return BuyerFavoritesApiApiFp(this.configuration).removeFavoriteProduct(storeId, favoriteIdListDto, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyerOrdersApiApi - axios parameter creator
 * @export
 */
export const BuyerOrdersApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {OrderItemGroupRatingsDto} orderItemGroupRatingsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptAndRateExpedition: async (orderCode: string, expeditionId: number, storeId: number, orderItemGroupRatingsDto: OrderItemGroupRatingsDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('acceptAndRateExpedition', 'orderCode', orderCode)
            // verify required parameter 'expeditionId' is not null or undefined
            assertParamExists('acceptAndRateExpedition', 'expeditionId', expeditionId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('acceptAndRateExpedition', 'storeId', storeId)
            // verify required parameter 'orderItemGroupRatingsDto' is not null or undefined
            assertParamExists('acceptAndRateExpedition', 'orderItemGroupRatingsDto', orderItemGroupRatingsDto)
            const localVarPath = `/api/v1/customer/buyer/orders/acceptAndRateExpedition/{orderCode}/{expeditionId}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)))
                .replace(`{${"expeditionId"}}`, encodeURIComponent(String(expeditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderItemGroupRatingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptExpedition: async (orderCode: string, expeditionId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('acceptExpedition', 'orderCode', orderCode)
            // verify required parameter 'expeditionId' is not null or undefined
            assertParamExists('acceptExpedition', 'expeditionId', expeditionId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('acceptExpedition', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/acceptExpedition/{orderCode}/{expeditionId}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)))
                .replace(`{${"expeditionId"}}`, encodeURIComponent(String(expeditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutCart: async (cartCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('checkOutCart', 'cartCode', cartCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('checkOutCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/checkout/{cartCode}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {DisputeDataDto} disputeDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeExpedition: async (orderCode: string, expeditionId: number, storeId: number, disputeDataDto: DisputeDataDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('disputeExpedition', 'orderCode', orderCode)
            // verify required parameter 'expeditionId' is not null or undefined
            assertParamExists('disputeExpedition', 'expeditionId', expeditionId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('disputeExpedition', 'storeId', storeId)
            // verify required parameter 'disputeDataDto' is not null or undefined
            assertParamExists('disputeExpedition', 'disputeDataDto', disputeDataDto)
            const localVarPath = `/api/v1/customer/buyer/orders/disputeExpedition/{orderCode}/{expeditionId}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)))
                .replace(`{${"expeditionId"}}`, encodeURIComponent(String(expeditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disputeDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByCode: async (orderCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('getOrderByCode', 'orderCode', orderCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderByCode', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/code/{orderCode}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderById', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderById', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsByCode1: async (orderCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('getOrderItemsByCode1', 'orderCode', orderCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderItemsByCode1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/code/{orderCode}/expeditions`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPaymentUpdateByCodeAction: async (orderCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('getOrderPaymentUpdateByCodeAction', 'orderCode', orderCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderPaymentUpdateByCodeAction', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/paymentComplete/code/{orderCode}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPaymentUpdateByIdAction: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderPaymentUpdateByIdAction', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderPaymentUpdateByIdAction', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/paymentComplete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProductById1: async (orderCode: string, productId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('getOrderProductById1', 'orderCode', orderCode)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getOrderProductById1', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderProductById1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/code/{orderCode}/product/{productId}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders1: async (storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listOrders1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAllCart: async (cartCode: string, state: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('moveAllCart', 'cartCode', cartCode)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('moveAllCart', 'state', state)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('moveAllCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/move/{cartCode}/{state}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {string} expedition 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCart: async (cartCode: string, expedition: string, state: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('moveCart', 'cartCode', cartCode)
            // verify required parameter 'expedition' is not null or undefined
            assertParamExists('moveCart', 'expedition', expedition)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('moveCart', 'state', state)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('moveCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/orders/move/{cartCode}/{expedition}/{state}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"expedition"}}`, encodeURIComponent(String(expedition)))
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerOrdersApiApi - functional programming interface
 * @export
 */
export const BuyerOrdersApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerOrdersApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {OrderItemGroupRatingsDto} orderItemGroupRatingsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptAndRateExpedition(orderCode: string, expeditionId: number, storeId: number, orderItemGroupRatingsDto: OrderItemGroupRatingsDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptAndRateExpedition(orderCode, expeditionId, storeId, orderItemGroupRatingsDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptExpedition(orderCode: string, expeditionId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptExpedition(orderCode, expeditionId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkOutCart(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkOutCart(cartCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {DisputeDataDto} disputeDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disputeExpedition(orderCode: string, expeditionId: number, storeId: number, disputeDataDto: DisputeDataDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disputeExpedition(orderCode, expeditionId, storeId, disputeDataDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderByCode(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderByCode(orderCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderById(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderById(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderItemsByCode1(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuyerOrderItemGroupSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderItemsByCode1(orderCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderPaymentUpdateByCodeAction(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderPaymentUpdateByCodeAction(orderCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderPaymentUpdateByIdAction(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderPaymentUpdateByIdAction(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderProductById1(orderCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderProductById1(orderCode, productId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrders1(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageOrderItxSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrders1(storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveAllCart(cartCode: string, state: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveAllCart(cartCode, state, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {string} expedition 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveCart(cartCode: string, expedition: string, state: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveCart(cartCode, expedition, state, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyerOrdersApiApi - factory interface
 * @export
 */
export const BuyerOrdersApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerOrdersApiApiFp(configuration)
    return {
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {OrderItemGroupRatingsDto} orderItemGroupRatingsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptAndRateExpedition(orderCode: string, expeditionId: number, storeId: number, orderItemGroupRatingsDto: OrderItemGroupRatingsDto, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.acceptAndRateExpedition(orderCode, expeditionId, storeId, orderItemGroupRatingsDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptExpedition(orderCode: string, expeditionId: number, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.acceptExpedition(orderCode, expeditionId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutCart(cartCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.checkOutCart(cartCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} expeditionId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {DisputeDataDto} disputeDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disputeExpedition(orderCode: string, expeditionId: number, storeId: number, disputeDataDto: DisputeDataDto, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.disputeExpedition(orderCode, expeditionId, storeId, disputeDataDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByCode(orderCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.getOrderByCode(orderCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.getOrderById(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsByCode1(orderCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<Array<BuyerOrderItemGroupSummaryDto>> {
            return localVarFp.getOrderItemsByCode1(orderCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPaymentUpdateByCodeAction(orderCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.getOrderPaymentUpdateByCodeAction(orderCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderPaymentUpdateByIdAction(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.getOrderPaymentUpdateByIdAction(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProductById1(orderCode: string, productId: number, storeId: number, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.getOrderProductById1(orderCode, productId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders1(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageOrderItxSummaryDto> {
            return localVarFp.listOrders1(storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAllCart(cartCode: string, state: string, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.moveAllCart(cartCode, state, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {string} expedition 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCart(cartCode: string, expedition: string, state: string, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItxDto> {
            return localVarFp.moveCart(cartCode, expedition, state, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerOrdersApiApi - interface
 * @export
 * @interface BuyerOrdersApiApi
 */
export interface BuyerOrdersApiApiInterface {
    /**
     * 
     * @param {string} orderCode 
     * @param {number} expeditionId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {OrderItemGroupRatingsDto} orderItemGroupRatingsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    acceptAndRateExpedition(orderCode: string, expeditionId: number, storeId: number, orderItemGroupRatingsDto: OrderItemGroupRatingsDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} expeditionId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    acceptExpedition(orderCode: string, expeditionId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    checkOutCart(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} expeditionId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {DisputeDataDto} disputeDataDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    disputeExpedition(orderCode: string, expeditionId: number, storeId: number, disputeDataDto: DisputeDataDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    getOrderByCode(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    getOrderById(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    getOrderItemsByCode1(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<BuyerOrderItemGroupSummaryDto>>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    getOrderPaymentUpdateByCodeAction(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    getOrderPaymentUpdateByIdAction(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    getOrderProductById1(orderCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    listOrders1(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageOrderItxSummaryDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    moveAllCart(cartCode: string, state: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {string} expedition 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApiInterface
     */
    moveCart(cartCode: string, expedition: string, state: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItxDto>;

}

/**
 * BuyerOrdersApiApi - object-oriented interface
 * @export
 * @class BuyerOrdersApiApi
 * @extends {BaseAPI}
 */
export class BuyerOrdersApiApi extends BaseAPI implements BuyerOrdersApiApiInterface {
    /**
     * 
     * @param {string} orderCode 
     * @param {number} expeditionId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {OrderItemGroupRatingsDto} orderItemGroupRatingsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public acceptAndRateExpedition(orderCode: string, expeditionId: number, storeId: number, orderItemGroupRatingsDto: OrderItemGroupRatingsDto, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).acceptAndRateExpedition(orderCode, expeditionId, storeId, orderItemGroupRatingsDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} expeditionId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public acceptExpedition(orderCode: string, expeditionId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).acceptExpedition(orderCode, expeditionId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public checkOutCart(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).checkOutCart(cartCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} expeditionId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {DisputeDataDto} disputeDataDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public disputeExpedition(orderCode: string, expeditionId: number, storeId: number, disputeDataDto: DisputeDataDto, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).disputeExpedition(orderCode, expeditionId, storeId, disputeDataDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public getOrderByCode(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).getOrderByCode(orderCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public getOrderById(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).getOrderById(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public getOrderItemsByCode1(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).getOrderItemsByCode1(orderCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public getOrderPaymentUpdateByCodeAction(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).getOrderPaymentUpdateByCodeAction(orderCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public getOrderPaymentUpdateByIdAction(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).getOrderPaymentUpdateByIdAction(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public getOrderProductById1(orderCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).getOrderProductById1(orderCode, productId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public listOrders1(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).listOrders1(storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public moveAllCart(cartCode: string, state: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).moveAllCart(cartCode, state, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {string} expedition 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerOrdersApiApi
     */
    public moveCart(cartCode: string, expedition: string, state: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerOrdersApiApiFp(this.configuration).moveCart(cartCode, expedition, state, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyerPersonalDataAPIApi - axios parameter creator
 * @export
 */
export const BuyerPersonalDataAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} address 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBillingAddress: async (address: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('addBillingAddress', 'address', address)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addBillingAddress', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/data/billing/{address}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} address 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReturnAddress: async (address: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('addReturnAddress', 'address', address)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addReturnAddress', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/data/returnAddress/{address}`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('get1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFinancialData: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCustomerFinancialData', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/data/financial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CustomerFinancialDataDto} customerFinancialDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomerFinancialData: async (storeId: number, customerFinancialDataDto: CustomerFinancialDataDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('setCustomerFinancialData', 'storeId', storeId)
            // verify required parameter 'customerFinancialDataDto' is not null or undefined
            assertParamExists('setCustomerFinancialData', 'customerFinancialDataDto', customerFinancialDataDto)
            const localVarPath = `/api/v1/customer/data/financial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerFinancialDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CustomerNicknameDto} customerNicknameDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomerNickname: async (storeId: number, customerNicknameDto: CustomerNicknameDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('setCustomerNickname', 'storeId', storeId)
            // verify required parameter 'customerNicknameDto' is not null or undefined
            assertParamExists('setCustomerNickname', 'customerNicknameDto', customerNicknameDto)
            const localVarPath = `/api/v1/customer/data/set-nickname`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerNicknameDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {boolean} body 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomerOffers: async (storeId: number, body: boolean, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('setCustomerOffers', 'storeId', storeId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setCustomerOffers', 'body', body)
            const localVarPath = `/api/v1/customer/data/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerPersonalDataAPIApi - functional programming interface
 * @export
 */
export const BuyerPersonalDataAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerPersonalDataAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} address 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBillingAddress(address: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerItxDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBillingAddress(address, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} address 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addReturnAddress(address: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerItxDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addReturnAddress(address, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerItxDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerFinancialData(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerFinancialDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerFinancialData(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CustomerFinancialDataDto} customerFinancialDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCustomerFinancialData(storeId: number, customerFinancialDataDto: CustomerFinancialDataDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerFinancialDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCustomerFinancialData(storeId, customerFinancialDataDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CustomerNicknameDto} customerNicknameDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCustomerNickname(storeId: number, customerNicknameDto: CustomerNicknameDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerItxDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCustomerNickname(storeId, customerNicknameDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {boolean} body 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCustomerOffers(storeId: number, body: boolean, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCustomerOffers(storeId, body, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyerPersonalDataAPIApi - factory interface
 * @export
 */
export const BuyerPersonalDataAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerPersonalDataAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {number} address 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBillingAddress(address: number, storeId: number, lang?: string, options?: any): AxiosPromise<CustomerItxDataDto> {
            return localVarFp.addBillingAddress(address, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} address 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReturnAddress(address: number, storeId: number, lang?: string, options?: any): AxiosPromise<CustomerItxDataDto> {
            return localVarFp.addReturnAddress(address, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(storeId: number, lang?: string, options?: any): AxiosPromise<CustomerItxDataDto> {
            return localVarFp.get1(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerFinancialData(storeId: number, lang?: string, options?: any): AxiosPromise<CustomerFinancialDataDto> {
            return localVarFp.getCustomerFinancialData(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CustomerFinancialDataDto} customerFinancialDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomerFinancialData(storeId: number, customerFinancialDataDto: CustomerFinancialDataDto, lang?: string, options?: any): AxiosPromise<CustomerFinancialDataDto> {
            return localVarFp.setCustomerFinancialData(storeId, customerFinancialDataDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CustomerNicknameDto} customerNicknameDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomerNickname(storeId: number, customerNicknameDto: CustomerNicknameDto, lang?: string, options?: any): AxiosPromise<CustomerItxDataDto> {
            return localVarFp.setCustomerNickname(storeId, customerNicknameDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {boolean} body 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomerOffers(storeId: number, body: boolean, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.setCustomerOffers(storeId, body, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerPersonalDataAPIApi - interface
 * @export
 * @interface BuyerPersonalDataAPIApi
 */
export interface BuyerPersonalDataAPIApiInterface {
    /**
     * 
     * @param {number} address 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    addBillingAddress(address: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerItxDataDto>;

    /**
     * 
     * @param {number} address 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    addReturnAddress(address: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerItxDataDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    get1(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerItxDataDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    getCustomerFinancialData(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerFinancialDataDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {CustomerFinancialDataDto} customerFinancialDataDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    setCustomerFinancialData(storeId: number, customerFinancialDataDto: CustomerFinancialDataDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerFinancialDataDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {CustomerNicknameDto} customerNicknameDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    setCustomerNickname(storeId: number, customerNicknameDto: CustomerNicknameDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CustomerItxDataDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {boolean} body 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApiInterface
     */
    setCustomerOffers(storeId: number, body: boolean, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * BuyerPersonalDataAPIApi - object-oriented interface
 * @export
 * @class BuyerPersonalDataAPIApi
 * @extends {BaseAPI}
 */
export class BuyerPersonalDataAPIApi extends BaseAPI implements BuyerPersonalDataAPIApiInterface {
    /**
     * 
     * @param {number} address 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public addBillingAddress(address: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).addBillingAddress(address, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} address 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public addReturnAddress(address: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).addReturnAddress(address, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public get1(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).get1(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public getCustomerFinancialData(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).getCustomerFinancialData(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {CustomerFinancialDataDto} customerFinancialDataDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public setCustomerFinancialData(storeId: number, customerFinancialDataDto: CustomerFinancialDataDto, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).setCustomerFinancialData(storeId, customerFinancialDataDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {CustomerNicknameDto} customerNicknameDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public setCustomerNickname(storeId: number, customerNicknameDto: CustomerNicknameDto, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).setCustomerNickname(storeId, customerNicknameDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {boolean} body 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerPersonalDataAPIApi
     */
    public setCustomerOffers(storeId: number, body: boolean, lang?: string, options?: AxiosRequestConfig) {
        return BuyerPersonalDataAPIApiFp(this.configuration).setCustomerOffers(storeId, body, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyerShippingOptionsAPIApi - axios parameter creator
 * @export
 */
export const BuyerShippingOptionsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOptions', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shippingOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerShippingOptionsAPIApi - functional programming interface
 * @export
 */
export const BuyerShippingOptionsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerShippingOptionsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptions(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShippingOptionsItxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptions(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyerShippingOptionsAPIApi - factory interface
 * @export
 */
export const BuyerShippingOptionsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerShippingOptionsAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions(storeId: number, lang?: string, options?: any): AxiosPromise<Array<ShippingOptionsItxDto>> {
            return localVarFp.getOptions(storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerShippingOptionsAPIApi - interface
 * @export
 * @interface BuyerShippingOptionsAPIApi
 */
export interface BuyerShippingOptionsAPIApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShippingOptionsAPIApiInterface
     */
    getOptions(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<ShippingOptionsItxDto>>;

}

/**
 * BuyerShippingOptionsAPIApi - object-oriented interface
 * @export
 * @class BuyerShippingOptionsAPIApi
 * @extends {BaseAPI}
 */
export class BuyerShippingOptionsAPIApi extends BaseAPI implements BuyerShippingOptionsAPIApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShippingOptionsAPIApi
     */
    public getOptions(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShippingOptionsAPIApiFp(this.configuration).getOptions(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyerShippingWithCustomCartAPIApi - axios parameter creator
 * @export
 */
export const BuyerShippingWithCustomCartAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list shipping methods
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} countryArrive ISO country arrive name
         * @param {string} countryDeparture ISO country desparture name
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingMethods: async (storeId: number, countryArrive: string, countryDeparture: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getShippingMethods', 'storeId', storeId)
            // verify required parameter 'countryArrive' is not null or undefined
            assertParamExists('getShippingMethods', 'countryArrive', countryArrive)
            // verify required parameter 'countryDeparture' is not null or undefined
            assertParamExists('getShippingMethods', 'countryDeparture', countryDeparture)
            const localVarPath = `/api/v1/customer/buyer/shipping/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (countryArrive !== undefined) {
                localVarQueryParameter['countryArrive'] = countryArrive;
            }

            if (countryDeparture !== undefined) {
                localVarQueryParameter['countryDeparture'] = countryDeparture;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list shipping methods
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<CartShippingItxDto>} cartShippingItxDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveShippingMethod: async (storeId: number, cartShippingItxDto: Array<CartShippingItxDto>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('saveShippingMethod', 'storeId', storeId)
            // verify required parameter 'cartShippingItxDto' is not null or undefined
            assertParamExists('saveShippingMethod', 'cartShippingItxDto', cartShippingItxDto)
            const localVarPath = `/api/v1/customer/buyer/shipping/cart/method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cartShippingItxDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerShippingWithCustomCartAPIApi - functional programming interface
 * @export
 */
export const BuyerShippingWithCustomCartAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerShippingWithCustomCartAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list shipping methods
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} countryArrive ISO country arrive name
         * @param {string} countryDeparture ISO country desparture name
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShippingMethods(storeId: number, countryArrive: string, countryDeparture: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShippingMethodItxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShippingMethods(storeId, countryArrive, countryDeparture, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list shipping methods
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<CartShippingItxDto>} cartShippingItxDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveShippingMethod(storeId: number, cartShippingItxDto: Array<CartShippingItxDto>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveShippingMethod(storeId, cartShippingItxDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyerShippingWithCustomCartAPIApi - factory interface
 * @export
 */
export const BuyerShippingWithCustomCartAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerShippingWithCustomCartAPIApiFp(configuration)
    return {
        /**
         * Get list shipping methods
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} countryArrive ISO country arrive name
         * @param {string} countryDeparture ISO country desparture name
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingMethods(storeId: number, countryArrive: string, countryDeparture: string, lang?: string, options?: any): AxiosPromise<Array<ShippingMethodItxDto>> {
            return localVarFp.getShippingMethods(storeId, countryArrive, countryDeparture, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list shipping methods
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<CartShippingItxDto>} cartShippingItxDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveShippingMethod(storeId: number, cartShippingItxDto: Array<CartShippingItxDto>, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.saveShippingMethod(storeId, cartShippingItxDto, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerShippingWithCustomCartAPIApi - interface
 * @export
 * @interface BuyerShippingWithCustomCartAPIApi
 */
export interface BuyerShippingWithCustomCartAPIApiInterface {
    /**
     * Get list shipping methods
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} countryArrive ISO country arrive name
     * @param {string} countryDeparture ISO country desparture name
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShippingWithCustomCartAPIApiInterface
     */
    getShippingMethods(storeId: number, countryArrive: string, countryDeparture: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<ShippingMethodItxDto>>;

    /**
     * Get list shipping methods
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<CartShippingItxDto>} cartShippingItxDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShippingWithCustomCartAPIApiInterface
     */
    saveShippingMethod(storeId: number, cartShippingItxDto: Array<CartShippingItxDto>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

}

/**
 * BuyerShippingWithCustomCartAPIApi - object-oriented interface
 * @export
 * @class BuyerShippingWithCustomCartAPIApi
 * @extends {BaseAPI}
 */
export class BuyerShippingWithCustomCartAPIApi extends BaseAPI implements BuyerShippingWithCustomCartAPIApiInterface {
    /**
     * Get list shipping methods
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} countryArrive ISO country arrive name
     * @param {string} countryDeparture ISO country desparture name
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShippingWithCustomCartAPIApi
     */
    public getShippingMethods(storeId: number, countryArrive: string, countryDeparture: string, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShippingWithCustomCartAPIApiFp(this.configuration).getShippingMethods(storeId, countryArrive, countryDeparture, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list shipping methods
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<CartShippingItxDto>} cartShippingItxDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShippingWithCustomCartAPIApi
     */
    public saveShippingMethod(storeId: number, cartShippingItxDto: Array<CartShippingItxDto>, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShippingWithCustomCartAPIApiFp(this.configuration).saveShippingMethod(storeId, cartShippingItxDto, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyerShoppingCartAPIApi - axios parameter creator
 * @export
 */
export const BuyerShoppingCartAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCartChanges: async (cartCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('acceptCartChanges', 'cartCode', cartCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('acceptCartChanges', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/acceptCartChanges/{cartCode}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCartChanges1: async (cartCode: string, productId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('acceptCartChanges1', 'cartCode', cartCode)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('acceptCartChanges1', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('acceptCartChanges1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/acceptCartChanges/{cartCode}/{productId}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} addressId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAddressToId: async (cartCode: string, addressId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('addAddressToId', 'cartCode', cartCode)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addAddressToId', 'addressId', addressId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addAddressToId', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/{cartCode}/address/{addressId}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToCart: async (cartCode: string, productId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('addProductToCart', 'cartCode', cartCode)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('addProductToCart', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addProductToCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/{cartCode}/{productId}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} shippingMethodId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addShippingMethodId: async (cartCode: string, shippingMethodId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('addShippingMethodId', 'cartCode', cartCode)
            // verify required parameter 'shippingMethodId' is not null or undefined
            assertParamExists('addShippingMethodId', 'shippingMethodId', shippingMethodId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addShippingMethodId', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/{cartCode}/shippingMethod/{shippingMethodId}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"shippingMethodId"}}`, encodeURIComponent(String(shippingMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [guestUserId] ID of the guest user from zara
         * @param {string} [externalStoreId] ID of the zara store from which the request is made
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1: async (productId: number, storeId: number, lang?: string, guestUserId?: number, externalStoreId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('create1', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('create1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/new/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (guestUserId !== undefined) {
                localVarQueryParameter['guestUserId'] = guestUserId;
            }

            if (externalStoreId !== undefined) {
                localVarQueryParameter['externalStoreId'] = externalStoreId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode Shopping cart code
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductListFromCart: async (cartCode: string, storeId: number, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('deleteProductListFromCart', 'cartCode', cartCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteProductListFromCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/removeProducts/{cartCode}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductToCart: async (cartCode: string, productId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('deleteProductToCart', 'cartCode', cartCode)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteProductToCart', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteProductToCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/{cartCode}/{productId}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCart: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCurrentCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCartV2: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCurrentCartV2', 'storeId', storeId)
            const localVarPath = `/api/v2/customer/buyer/shoppingcart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductToCart: async (cartCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartCode' is not null or undefined
            assertParamExists('getProductToCart', 'cartCode', cartCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductToCart', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/buyer/shoppingcart/{cartCode}`
                .replace(`{${"cartCode"}}`, encodeURIComponent(String(cartCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyerShoppingCartAPIApi - functional programming interface
 * @export
 */
export const BuyerShoppingCartAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyerShoppingCartAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptCartChanges(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptCartChanges(cartCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptCartChanges1(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptCartChanges1(cartCode, productId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} addressId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAddressToId(cartCode: string, addressId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAddressToId(cartCode, addressId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductToCart(cartCode, productId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} shippingMethodId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addShippingMethodId(cartCode: string, shippingMethodId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addShippingMethodId(cartCode, shippingMethodId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [guestUserId] ID of the guest user from zara
         * @param {string} [externalStoreId] ID of the zara store from which the request is made
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create1(productId: number, storeId: number, lang?: string, guestUserId?: number, externalStoreId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create1(productId, storeId, lang, guestUserId, externalStoreId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode Shopping cart code
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductListFromCart(cartCode: string, storeId: number, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductListFromCart(cartCode, storeId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductToCart(cartCode, productId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCart(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCart(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCartV2(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCartV2(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductToCart(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductToCart(cartCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyerShoppingCartAPIApi - factory interface
 * @export
 */
export const BuyerShoppingCartAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyerShoppingCartAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCartChanges(cartCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.acceptCartChanges(cartCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCartChanges1(cartCode: string, productId: number, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.acceptCartChanges1(cartCode, productId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} addressId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAddressToId(cartCode: string, addressId: number, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.addAddressToId(cartCode, addressId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.addProductToCart(cartCode, productId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} shippingMethodId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addShippingMethodId(cartCode: string, shippingMethodId: number, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.addShippingMethodId(cartCode, shippingMethodId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [guestUserId] ID of the guest user from zara
         * @param {string} [externalStoreId] ID of the zara store from which the request is made
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(productId: number, storeId: number, lang?: string, guestUserId?: number, externalStoreId?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.create1(productId, storeId, lang, guestUserId, externalStoreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode Shopping cart code
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductListFromCart(cartCode: string, storeId: number, requestBody?: Array<number>, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.deleteProductListFromCart(cartCode, storeId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.deleteProductToCart(cartCode, productId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCart(storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.getCurrentCart(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCartV2(storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.getCurrentCartV2(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cartCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductToCart(cartCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<ShoppingCartItxDto> {
            return localVarFp.getProductToCart(cartCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyerShoppingCartAPIApi - interface
 * @export
 * @interface BuyerShoppingCartAPIApi
 */
export interface BuyerShoppingCartAPIApiInterface {
    /**
     * 
     * @param {string} cartCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    acceptCartChanges(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    acceptCartChanges1(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} addressId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    addAddressToId(cartCode: string, addressId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    addProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} shippingMethodId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    addShippingMethodId(cartCode: string, shippingMethodId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [guestUserId] ID of the guest user from zara
     * @param {string} [externalStoreId] ID of the zara store from which the request is made
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    create1(productId: number, storeId: number, lang?: string, guestUserId?: number, externalStoreId?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode Shopping cart code
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    deleteProductListFromCart(cartCode: string, storeId: number, requestBody?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    deleteProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    getCurrentCart(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    getCurrentCartV2(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

    /**
     * 
     * @param {string} cartCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApiInterface
     */
    getProductToCart(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ShoppingCartItxDto>;

}

/**
 * BuyerShoppingCartAPIApi - object-oriented interface
 * @export
 * @class BuyerShoppingCartAPIApi
 * @extends {BaseAPI}
 */
export class BuyerShoppingCartAPIApi extends BaseAPI implements BuyerShoppingCartAPIApiInterface {
    /**
     * 
     * @param {string} cartCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public acceptCartChanges(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).acceptCartChanges(cartCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public acceptCartChanges1(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).acceptCartChanges1(cartCode, productId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} addressId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public addAddressToId(cartCode: string, addressId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).addAddressToId(cartCode, addressId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public addProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).addProductToCart(cartCode, productId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} shippingMethodId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public addShippingMethodId(cartCode: string, shippingMethodId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).addShippingMethodId(cartCode, shippingMethodId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [guestUserId] ID of the guest user from zara
     * @param {string} [externalStoreId] ID of the zara store from which the request is made
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public create1(productId: number, storeId: number, lang?: string, guestUserId?: number, externalStoreId?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).create1(productId, storeId, lang, guestUserId, externalStoreId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode Shopping cart code
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public deleteProductListFromCart(cartCode: string, storeId: number, requestBody?: Array<number>, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).deleteProductListFromCart(cartCode, storeId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public deleteProductToCart(cartCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).deleteProductToCart(cartCode, productId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public getCurrentCart(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).getCurrentCart(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public getCurrentCartV2(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).getCurrentCartV2(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cartCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyerShoppingCartAPIApi
     */
    public getProductToCart(cartCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return BuyerShoppingCartAPIApiFp(this.configuration).getProductToCart(cartCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerAuthManagementAPIApi - axios parameter creator
 * @export
 */
export const CustomerAuthManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authorize customer user using a Zara multipass token
         * @param {string} token 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate: async (token: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authenticate', 'token', token)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('authenticate', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/restauth/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate1: async (token: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authenticate1', 'token', token)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('authenticate1', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/auth/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerAuthManagementAPIApi - functional programming interface
 * @export
 */
export const CustomerAuthManagementAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerAuthManagementAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authorize customer user using a Zara multipass token
         * @param {string} token 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticate(token: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticate(token, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticate1(token: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticate1(token, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerAuthManagementAPIApi - factory interface
 * @export
 */
export const CustomerAuthManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerAuthManagementAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Authorize customer user using a Zara multipass token
         * @param {string} token 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate(token: string, storeId: number, lang?: string, options?: any): AxiosPromise<AuthenticationResponse> {
            return localVarFp.authenticate(token, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate1(token: string, storeId: number, lang?: string, options?: any): AxiosPromise<RedirectView> {
            return localVarFp.authenticate1(token, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerAuthManagementAPIApi - interface
 * @export
 * @interface CustomerAuthManagementAPIApi
 */
export interface CustomerAuthManagementAPIApiInterface {
    /**
     * 
     * @summary Authorize customer user using a Zara multipass token
     * @param {string} token 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAuthManagementAPIApiInterface
     */
    authenticate(token: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @param {string} token 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAuthManagementAPIApiInterface
     */
    authenticate1(token: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<RedirectView>;

}

/**
 * CustomerAuthManagementAPIApi - object-oriented interface
 * @export
 * @class CustomerAuthManagementAPIApi
 * @extends {BaseAPI}
 */
export class CustomerAuthManagementAPIApi extends BaseAPI implements CustomerAuthManagementAPIApiInterface {
    /**
     * 
     * @summary Authorize customer user using a Zara multipass token
     * @param {string} token 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAuthManagementAPIApi
     */
    public authenticate(token: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return CustomerAuthManagementAPIApiFp(this.configuration).authenticate(token, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAuthManagementAPIApi
     */
    public authenticate1(token: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return CustomerAuthManagementAPIApiFp(this.configuration).authenticate1(token, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductPropertySetReadAPIApi - axios parameter creator
 * @export
 */
export const ProductPropertySetReadAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('get', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/property/set/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'COLOR' | 'SIZE' | 'CONDITION'} typeCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByType: async (typeCode: 'COLOR' | 'SIZE' | 'CONDITION', storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeCode' is not null or undefined
            assertParamExists('getByType', 'typeCode', typeCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getByType', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/property/setByType/{typeCode}`
                .replace(`{${"typeCode"}}`, encodeURIComponent(String(typeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('list', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/property/set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPropertySetReadAPIApi - functional programming interface
 * @export
 */
export const ProductPropertySetReadAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPropertySetReadAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptionValueSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'COLOR' | 'SIZE' | 'CONDITION'} typeCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByType(typeCode: 'COLOR' | 'SIZE' | 'CONDITION', storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionValueSet>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByType(typeCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionValueSet>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductPropertySetReadAPIApi - factory interface
 * @export
 */
export const ProductPropertySetReadAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPropertySetReadAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<OptionValueSet> {
            return localVarFp.get(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'COLOR' | 'SIZE' | 'CONDITION'} typeCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByType(typeCode: 'COLOR' | 'SIZE' | 'CONDITION', storeId: number, lang?: string, options?: any): AxiosPromise<Array<OptionValueSet>> {
            return localVarFp.getByType(typeCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(storeId: number, lang?: string, options?: any): AxiosPromise<Array<OptionValueSet>> {
            return localVarFp.list(storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductPropertySetReadAPIApi - interface
 * @export
 * @interface ProductPropertySetReadAPIApi
 */
export interface ProductPropertySetReadAPIApiInterface {
    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPropertySetReadAPIApiInterface
     */
    get(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OptionValueSet>;

    /**
     * 
     * @param {'COLOR' | 'SIZE' | 'CONDITION'} typeCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPropertySetReadAPIApiInterface
     */
    getByType(typeCode: 'COLOR' | 'SIZE' | 'CONDITION', storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<OptionValueSet>>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPropertySetReadAPIApiInterface
     */
    list(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<OptionValueSet>>;

}

/**
 * ProductPropertySetReadAPIApi - object-oriented interface
 * @export
 * @class ProductPropertySetReadAPIApi
 * @extends {BaseAPI}
 */
export class ProductPropertySetReadAPIApi extends BaseAPI implements ProductPropertySetReadAPIApiInterface {
    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPropertySetReadAPIApi
     */
    public get(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ProductPropertySetReadAPIApiFp(this.configuration).get(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'COLOR' | 'SIZE' | 'CONDITION'} typeCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPropertySetReadAPIApi
     */
    public getByType(typeCode: 'COLOR' | 'SIZE' | 'CONDITION', storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ProductPropertySetReadAPIApiFp(this.configuration).getByType(typeCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPropertySetReadAPIApi
     */
    public list(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ProductPropertySetReadAPIApiFp(this.configuration).list(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SellerCategoriesManagementAPIApi - axios parameter creator
 * @export
 */
export const SellerCategoriesManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a category by id
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryById', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCategoryById', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get visible categories list
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisibleCategories: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listVisibleCategories', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerCategoriesManagementAPIApi - functional programming interface
 * @export
 */
export const SellerCategoriesManagementAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerCategoriesManagementAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a category by id
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryById(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Category>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryById(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get visible categories list
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVisibleCategories(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVisibleCategories(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerCategoriesManagementAPIApi - factory interface
 * @export
 */
export const SellerCategoriesManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerCategoriesManagementAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a category by id
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<Category> {
            return localVarFp.getCategoryById(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get visible categories list
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisibleCategories(storeId: number, lang?: string, options?: any): AxiosPromise<Array<Category>> {
            return localVarFp.listVisibleCategories(storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SellerCategoriesManagementAPIApi - interface
 * @export
 * @interface SellerCategoriesManagementAPIApi
 */
export interface SellerCategoriesManagementAPIApiInterface {
    /**
     * 
     * @summary Get a category by id
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerCategoriesManagementAPIApiInterface
     */
    getCategoryById(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Category>;

    /**
     * 
     * @summary Get visible categories list
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerCategoriesManagementAPIApiInterface
     */
    listVisibleCategories(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Category>>;

}

/**
 * SellerCategoriesManagementAPIApi - object-oriented interface
 * @export
 * @class SellerCategoriesManagementAPIApi
 * @extends {BaseAPI}
 */
export class SellerCategoriesManagementAPIApi extends BaseAPI implements SellerCategoriesManagementAPIApiInterface {
    /**
     * 
     * @summary Get a category by id
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerCategoriesManagementAPIApi
     */
    public getCategoryById(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerCategoriesManagementAPIApiFp(this.configuration).getCategoryById(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get visible categories list
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerCategoriesManagementAPIApi
     */
    public listVisibleCategories(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerCategoriesManagementAPIApiFp(this.configuration).listVisibleCategories(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SellerOrdersApiApi - axios parameter creator
 * @export
 */
export const SellerOrdersApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsByCode: async (orderCode: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('getOrderItemsByCode', 'orderCode', orderCode)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderItemsByCode', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/seller/orders/code/{orderCode}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProductById: async (orderCode: string, productId: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCode' is not null or undefined
            assertParamExists('getOrderProductById', 'orderCode', orderCode)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getOrderProductById', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOrderProductById', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/seller/orders/code/{orderCode}/product/{productId}`
                .replace(`{${"orderCode"}}`, encodeURIComponent(String(orderCode)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: async (storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listOrders', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/seller/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerOrdersApiApi - functional programming interface
 * @export
 */
export const SellerOrdersApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerOrdersApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderItemsByCode(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderItemGroupItxDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderItemsByCode(orderCode, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderProductById(orderCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderProductById(orderCode, productId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrders(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSellerOrderItemGroupSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrders(storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerOrdersApiApi - factory interface
 * @export
 */
export const SellerOrdersApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerOrdersApiApiFp(configuration)
    return {
        /**
         * 
         * @param {string} orderCode 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsByCode(orderCode: string, storeId: number, lang?: string, options?: any): AxiosPromise<OrderItemGroupItxDetailDto> {
            return localVarFp.getOrderItemsByCode(orderCode, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderCode 
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProductById(orderCode: string, productId: number, storeId: number, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.getOrderProductById(orderCode, productId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageSellerOrderItemGroupSummaryDto> {
            return localVarFp.listOrders(storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SellerOrdersApiApi - interface
 * @export
 * @interface SellerOrdersApiApi
 */
export interface SellerOrdersApiApiInterface {
    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerOrdersApiApiInterface
     */
    getOrderItemsByCode(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<OrderItemGroupItxDetailDto>;

    /**
     * 
     * @param {string} orderCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerOrdersApiApiInterface
     */
    getOrderProductById(orderCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerOrdersApiApiInterface
     */
    listOrders(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageSellerOrderItemGroupSummaryDto>;

}

/**
 * SellerOrdersApiApi - object-oriented interface
 * @export
 * @class SellerOrdersApiApi
 * @extends {BaseAPI}
 */
export class SellerOrdersApiApi extends BaseAPI implements SellerOrdersApiApiInterface {
    /**
     * 
     * @param {string} orderCode 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerOrdersApiApi
     */
    public getOrderItemsByCode(orderCode: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerOrdersApiApiFp(this.configuration).getOrderItemsByCode(orderCode, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderCode 
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerOrdersApiApi
     */
    public getOrderProductById(orderCode: string, productId: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerOrdersApiApiFp(this.configuration).getOrderProductById(orderCode, productId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerOrdersApiApi
     */
    public listOrders(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SellerOrdersApiApiFp(this.configuration).listOrders(storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SellerProductAPIApi - axios parameter creator
 * @export
 */
export const SellerProductAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductInput} productInput 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (storeId: number, productInput: ProductInput, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('create', 'storeId', storeId)
            // verify required parameter 'productInput' is not null or undefined
            assertParamExists('create', 'productInput', productInput)
            const localVarPath = `/api/v1/customer/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CategoriesAskForDetails} categoriesAskForDetails 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAskForDetails: async (id: number, storeId: number, categoriesAskForDetails: CategoriesAskForDetails, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createAskForDetails', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('createAskForDetails', 'storeId', storeId)
            // verify required parameter 'categoriesAskForDetails' is not null or undefined
            assertParamExists('createAskForDetails', 'categoriesAskForDetails', categoriesAskForDetails)
            const localVarPath = `/api/v1/customer/product/ask-for-details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoriesAskForDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductListing: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProductListing', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteProductListing', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete multiple products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductsListing: async (storeId: number, productIdsDto: ProductIdsDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteProductsListing', 'storeId', storeId)
            // verify required parameter 'productIdsDto' is not null or undefined
            assertParamExists('deleteProductsListing', 'productIdsDto', productIdsDto)
            const localVarPath = `/api/v1/customer/product/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deprecatedListByState: async (state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('deprecatedListByState', 'state', state)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deprecatedListByState', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/by-sate/{state}`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deprecatedSummaryByState: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deprecatedSummaryByState', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/by-sate-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ComplaintProductDataDto} complaintProductDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProductComplaint: async (storeId: number, complaintProductDataDto: ComplaintProductDataDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('fileProductComplaint', 'storeId', storeId)
            // verify required parameter 'complaintProductDataDto' is not null or undefined
            assertParamExists('fileProductComplaint', 'complaintProductDataDto', complaintProductDataDto)
            const localVarPath = `/api/v1/customer/product/complaint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(complaintProductDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComplaintReasons: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getAllComplaintReasons', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/complaint/reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product listing details
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtendedDTo: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExtendedDTo', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getExtendedDTo', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/extended/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxStoreRates: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getMaxStoreRates', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/maxStoreRates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product listing details
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTo: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTo', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getTo', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActive: async (storeId: number, page?: number, count?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listActive', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByState: async (state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('listByState', 'state', state)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listByState', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/by-state/{state}`
                .replace(`{${"state"}}`, encodeURIComponent(String(state)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyProducts: async (storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listMyProducts', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/my-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPending: async (storeId: number, page?: number, count?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listPending', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseAll: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('pauseAll', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/pause-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pause product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseProductListing: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pauseProductListing', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('pauseProductListing', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/{id}/pause`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pause products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseProductsListing: async (storeId: number, productIdsDto: ProductIdsDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('pauseProductsListing', 'storeId', storeId)
            // verify required parameter 'productIdsDto' is not null or undefined
            assertParamExists('pauseProductsListing', 'productIdsDto', productIdsDto)
            const localVarPath = `/api/v1/customer/product/pause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryByState: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('summaryByState', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/by-state-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pause products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unPauseProductsListing: async (storeId: number, productIdsDto: ProductIdsDto, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('unPauseProductsListing', 'storeId', storeId)
            // verify required parameter 'productIdsDto' is not null or undefined
            assertParamExists('unPauseProductsListing', 'productIdsDto', productIdsDto)
            const localVarPath = `/api/v1/customer/product/unpause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productIdsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpauseAll: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('unpauseAll', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/unpause-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unpause product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpauseProductListing: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unpauseProductListing', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('unpauseProductListing', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/product/{id}/unpause`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductInput} productInput 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, storeId: number, productInput: ProductInput, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('update', 'storeId', storeId)
            // verify required parameter 'productInput' is not null or undefined
            assertParamExists('update', 'productInput', productInput)
            const localVarPath = `/api/v1/customer/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerProductAPIApi - functional programming interface
 * @export
 */
export const SellerProductAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerProductAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductInput} productInput 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(storeId: number, productInput: ProductInput, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(storeId, productInput, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CategoriesAskForDetails} categoriesAskForDetails 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAskForDetails(id: number, storeId: number, categoriesAskForDetails: CategoriesAskForDetails, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAskForDetails(id, storeId, categoriesAskForDetails, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductListing(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete multiple products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductsListing(storeId, productIdsDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deprecatedListByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecatedListByState(state, storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deprecatedSummaryByState(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecatedSummaryByState(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ComplaintProductDataDto} complaintProductDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileProductComplaint(storeId: number, complaintProductDataDto: ComplaintProductDataDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplaintProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileProductComplaint(storeId, complaintProductDataDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllComplaintReasons(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComplaintReasonItxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllComplaintReasons(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get product listing details
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExtendedDTo(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductExtended>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExtendedDTo(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaxStoreRates(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaxStoreRates>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaxStoreRates(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get product listing details
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTo(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTo(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActive(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActive(storeId, page, count, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByState(state, storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyProducts(storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPending(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPending(storeId, page, count, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseAll(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseAll(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Pause product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseProductListing(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Pause products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseProductsListing(storeId, productIdsDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summaryByState(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summaryByState(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Pause products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unPauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unPauseProductsListing(storeId, productIdsDto, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpauseAll(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpauseAll(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unpause product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpauseProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpauseProductListing(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductInput} productInput 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, storeId: number, productInput: ProductInput, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, storeId, productInput, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerProductAPIApi - factory interface
 * @export
 */
export const SellerProductAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerProductAPIApiFp(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductInput} productInput 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(storeId: number, productInput: ProductInput, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.create(storeId, productInput, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {CategoriesAskForDetails} categoriesAskForDetails 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAskForDetails(id: number, storeId: number, categoriesAskForDetails: CategoriesAskForDetails, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.createAskForDetails(id, storeId, categoriesAskForDetails, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductListing(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.deleteProductListing(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete multiple products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: any): AxiosPromise<Array<Product>> {
            return localVarFp.deleteProductsListing(storeId, productIdsDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deprecatedListByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProduct> {
            return localVarFp.deprecatedListByState(state, storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deprecatedSummaryByState(storeId: number, lang?: string, options?: any): AxiosPromise<ProductStateDto> {
            return localVarFp.deprecatedSummaryByState(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ComplaintProductDataDto} complaintProductDataDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileProductComplaint(storeId: number, complaintProductDataDto: ComplaintProductDataDto, lang?: string, options?: any): AxiosPromise<ComplaintProductDataDto> {
            return localVarFp.fileProductComplaint(storeId, complaintProductDataDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComplaintReasons(storeId: number, lang?: string, options?: any): AxiosPromise<Array<ComplaintReasonItxDto>> {
            return localVarFp.getAllComplaintReasons(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product listing details
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtendedDTo(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<ProductExtended> {
            return localVarFp.getExtendedDTo(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxStoreRates(storeId: number, lang?: string, options?: any): AxiosPromise<MaxStoreRates> {
            return localVarFp.getMaxStoreRates(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product listing details
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTo(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.getTo(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActive(storeId: number, page?: number, count?: number, lang?: string, options?: any): AxiosPromise<Array<Product>> {
            return localVarFp.listActive(storeId, page, count, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} state 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProduct> {
            return localVarFp.listByState(state, storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageProduct> {
            return localVarFp.listMyProducts(storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPending(storeId: number, page?: number, count?: number, lang?: string, options?: any): AxiosPromise<Array<Product>> {
            return localVarFp.listPending(storeId, page, count, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseAll(storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pauseAll(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Pause product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseProductListing(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.pauseProductListing(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Pause products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: any): AxiosPromise<Array<Product>> {
            return localVarFp.pauseProductsListing(storeId, productIdsDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaryByState(storeId: number, lang?: string, options?: any): AxiosPromise<ProductStateDto> {
            return localVarFp.summaryByState(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Pause products listing
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductIdsDto} productIdsDto 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unPauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: any): AxiosPromise<Array<Product>> {
            return localVarFp.unPauseProductsListing(storeId, productIdsDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpauseAll(storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.unpauseAll(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Unpause product listing
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpauseProductListing(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.unpauseProductListing(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ProductInput} productInput 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, storeId: number, productInput: ProductInput, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.update(id, storeId, productInput, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SellerProductAPIApi - interface
 * @export
 * @interface SellerProductAPIApi
 */
export interface SellerProductAPIApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductInput} productInput 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    create(storeId: number, productInput: ProductInput, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {CategoriesAskForDetails} categoriesAskForDetails 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    createAskForDetails(id: number, storeId: number, categoriesAskForDetails: CategoriesAskForDetails, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete product listing
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    deleteProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * Delete multiple products listing
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductIdsDto} productIdsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    deleteProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Product>>;

    /**
     * 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    deprecatedListByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProduct>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    deprecatedSummaryByState(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ProductStateDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ComplaintProductDataDto} complaintProductDataDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    fileProductComplaint(storeId: number, complaintProductDataDto: ComplaintProductDataDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ComplaintProductDataDto>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    getAllComplaintReasons(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<ComplaintReasonItxDto>>;

    /**
     * Get product listing details
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    getExtendedDTo(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ProductExtended>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    getMaxStoreRates(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<MaxStoreRates>;

    /**
     * Get product listing details
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    getTo(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    listActive(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Product>>;

    /**
     * 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    listByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProduct>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    listMyProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageProduct>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    listPending(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Product>>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    pauseAll(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Pause product listing
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    pauseProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * Pause products listing
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductIdsDto} productIdsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    pauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Product>>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    summaryByState(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ProductStateDto>;

    /**
     * Pause products listing
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductIdsDto} productIdsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    unPauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Product>>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    unpauseAll(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Unpause product listing
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    unpauseProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductInput} productInput 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApiInterface
     */
    update(id: number, storeId: number, productInput: ProductInput, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

}

/**
 * SellerProductAPIApi - object-oriented interface
 * @export
 * @class SellerProductAPIApi
 * @extends {BaseAPI}
 */
export class SellerProductAPIApi extends BaseAPI implements SellerProductAPIApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductInput} productInput 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public create(storeId: number, productInput: ProductInput, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).create(storeId, productInput, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {CategoriesAskForDetails} categoriesAskForDetails 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public createAskForDetails(id: number, storeId: number, categoriesAskForDetails: CategoriesAskForDetails, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).createAskForDetails(id, storeId, categoriesAskForDetails, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete product listing
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public deleteProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).deleteProductListing(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete multiple products listing
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductIdsDto} productIdsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public deleteProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).deleteProductsListing(storeId, productIdsDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public deprecatedListByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).deprecatedListByState(state, storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public deprecatedSummaryByState(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).deprecatedSummaryByState(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ComplaintProductDataDto} complaintProductDataDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public fileProductComplaint(storeId: number, complaintProductDataDto: ComplaintProductDataDto, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).fileProductComplaint(storeId, complaintProductDataDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public getAllComplaintReasons(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).getAllComplaintReasons(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product listing details
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public getExtendedDTo(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).getExtendedDTo(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public getMaxStoreRates(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).getMaxStoreRates(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product listing details
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public getTo(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).getTo(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public listActive(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).listActive(storeId, page, count, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} state 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public listByState(state: string, storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).listByState(state, storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public listMyProducts(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).listMyProducts(storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public listPending(storeId: number, page?: number, count?: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).listPending(storeId, page, count, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public pauseAll(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).pauseAll(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pause product listing
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public pauseProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).pauseProductListing(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pause products listing
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductIdsDto} productIdsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public pauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).pauseProductsListing(storeId, productIdsDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public summaryByState(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).summaryByState(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pause products listing
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductIdsDto} productIdsDto 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public unPauseProductsListing(storeId: number, productIdsDto: ProductIdsDto, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).unPauseProductsListing(storeId, productIdsDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public unpauseAll(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).unpauseAll(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unpause product listing
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public unpauseProductListing(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).unpauseProductListing(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ProductInput} productInput 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerProductAPIApi
     */
    public update(id: number, storeId: number, productInput: ProductInput, lang?: string, options?: AxiosRequestConfig) {
        return SellerProductAPIApiFp(this.configuration).update(id, storeId, productInput, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SellerStripeConnectAPIApi - axios parameter creator
 * @export
 */
export const SellerStripeConnectAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete stripe account
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteAccount', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/stripe/connect-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get stripe dashboard login link
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardLoginLink: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getDashboardLoginLink', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/stripe/dashboard-login-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get stripe onboarding link
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingLink: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getOnboardingLink', 'storeId', storeId)
            const localVarPath = `/api/v1/customer/stripe/connect-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerStripeConnectAPIApi - functional programming interface
 * @export
 */
export const SellerStripeConnectAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerStripeConnectAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete stripe account
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get stripe dashboard login link
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardLoginLink(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeDashboardLoginLinkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardLoginLink(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get stripe onboarding link
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingLink(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeOnboardingLinkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingLink(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerStripeConnectAPIApi - factory interface
 * @export
 */
export const SellerStripeConnectAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerStripeConnectAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete stripe account
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAccount(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get stripe dashboard login link
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardLoginLink(storeId: number, lang?: string, options?: any): AxiosPromise<StripeDashboardLoginLinkDto> {
            return localVarFp.getDashboardLoginLink(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get stripe onboarding link
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingLink(storeId: number, lang?: string, options?: any): AxiosPromise<StripeOnboardingLinkDto> {
            return localVarFp.getOnboardingLink(storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SellerStripeConnectAPIApi - interface
 * @export
 * @interface SellerStripeConnectAPIApi
 */
export interface SellerStripeConnectAPIApiInterface {
    /**
     * 
     * @summary Delete stripe account
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeConnectAPIApiInterface
     */
    deleteAccount(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get stripe dashboard login link
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeConnectAPIApiInterface
     */
    getDashboardLoginLink(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<StripeDashboardLoginLinkDto>;

    /**
     * 
     * @summary Get stripe onboarding link
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeConnectAPIApiInterface
     */
    getOnboardingLink(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<StripeOnboardingLinkDto>;

}

/**
 * SellerStripeConnectAPIApi - object-oriented interface
 * @export
 * @class SellerStripeConnectAPIApi
 * @extends {BaseAPI}
 */
export class SellerStripeConnectAPIApi extends BaseAPI implements SellerStripeConnectAPIApiInterface {
    /**
     * 
     * @summary Delete stripe account
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeConnectAPIApi
     */
    public deleteAccount(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerStripeConnectAPIApiFp(this.configuration).deleteAccount(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get stripe dashboard login link
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeConnectAPIApi
     */
    public getDashboardLoginLink(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerStripeConnectAPIApiFp(this.configuration).getDashboardLoginLink(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get stripe onboarding link
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeConnectAPIApi
     */
    public getOnboardingLink(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return SellerStripeConnectAPIApiFp(this.configuration).getOnboardingLink(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


